// Auto-generated from icon.spec.js
export default {
  "tagName": "ui-icon",
  "content": [
    "icon"
  ],
  "contentAttributes": [
    "icon"
  ],
  "variations": [
    "link",
    "fitted",
    "color",
    "size",
    "size",
    "spin"
  ],
  "states": [
    "disabled",
    "loading"
  ],
  "settings": [
    "set",
    "href",
    "target"
  ],
  "attributes": [
    "icon",
    "disabled",
    "loading",
    "link",
    "fitted",
    "color",
    "size",
    "size",
    "spin",
    "set",
    "href",
    "target"
  ],
  "optionAttributes": {
    "disabled": "disabled",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "slate": "color",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size",
    "clickable-disabled": "disabled",
    "arrow-down": "icon",
    "arrow-left": "icon",
    "arrow-left-right": "icon",
    "arrow-right": "icon",
    "arrow-up": "icon",
    "arrow-up-down": "icon",
    "chevron-down": "icon",
    "chevron-first": "icon",
    "chevron-last": "icon",
    "chevron-left": "icon",
    "chevron-right": "icon",
    "chevron-up": "icon",
    "chevrons-down-up": "icon",
    "chevrons-left-right": "icon",
    "chevrons-up-down": "icon",
    "compass": "icon",
    "corner-down-left": "icon",
    "corner-down-right": "icon",
    "crosshair": "icon",
    "external-link": "icon",
    "home": "icon",
    "layout-panel-left": "icon",
    "layout-panel-top": "icon",
    "menu": "icon",
    "mouse-pointer": "icon",
    "archive": "icon",
    "archive-restore": "icon",
    "archive-x": "icon",
    "arrow-down-a-z": "icon",
    "arrow-up-a-z": "icon",
    "bookmark": "icon",
    "bookmark-check": "icon",
    "bookmark-plus": "icon",
    "circle-ellipsis": "icon",
    "circle-minus": "icon",
    "circle-plus": "icon",
    "circle-x": "icon",
    "clipboard": "icon",
    "clipboard-paste": "icon",
    "cloud-download": "icon",
    "cloud-upload": "icon",
    "copy": "icon",
    "copy-check": "icon",
    "backspace": "icon",
    "download": "icon",
    "ellipsis": "icon",
    "ellipsis-vertical": "icon",
    "expand": "icon",
    "eye": "icon",
    "eye-off": "icon",
    "grip-horizontal": "icon",
    "grip-vertical": "icon",
    "hand": "icon",
    "heart": "icon",
    "heart-off": "icon",
    "link-icon": "icon",
    "list-checks": "icon",
    "maximize": "icon",
    "merge": "icon",
    "minimize": "icon",
    "minus": "icon",
    "mouse-pointer-click": "icon",
    "move": "icon",
    "paperclip": "icon",
    "pencil": "icon",
    "pin": "icon",
    "pin-off": "icon",
    "plus": "icon",
    "redo": "icon",
    "refresh": "icon",
    "replace": "icon",
    "rocket": "icon",
    "rotate-ccw": "icon",
    "rotate-cw": "icon",
    "save": "icon",
    "scan": "icon",
    "scissors": "icon",
    "search": "icon",
    "share": "icon",
    "split": "icon",
    "thumbs-down": "icon",
    "thumbs-up": "icon",
    "trash": "icon",
    "undo": "icon",
    "unlink": "icon",
    "upload": "icon",
    "vote": "icon",
    "x": "icon",
    "zoom-in": "icon",
    "zoom-out": "icon",
    "badge-alert": "icon",
    "badge-check": "icon",
    "badge-info": "icon",
    "ban": "icon",
    "check": "icon",
    "check-check": "icon",
    "error": "icon",
    "circle-check": "icon",
    "circle-dashed": "icon",
    "help": "icon",
    "construction": "icon",
    "flag": "icon",
    "flame": "icon",
    "frown": "icon",
    "info": "icon",
    "life-buoy": "icon",
    "loader": "icon",
    "loader-circle": "icon",
    "meh": "icon",
    "server-crash": "icon",
    "warning": "icon",
    "bolt": "icon",
    "avatar": "icon",
    "contact": "icon",
    "id-card": "icon",
    "user": "icon",
    "user-check": "icon",
    "user-cog": "icon",
    "user-minus": "icon",
    "user-plus": "icon",
    "user-search": "icon",
    "user-x": "icon",
    "users": "icon",
    "circle-dot": "icon",
    "password": "icon",
    "square-check": "icon",
    "text-cursor-input": "icon",
    "toggle-left": "icon",
    "toggle-right": "icon",
    "activity": "icon",
    "chart-area": "icon",
    "chart-bar": "icon",
    "chart-bar-stacked": "icon",
    "chart-candlestick": "icon",
    "chart-gantt": "icon",
    "chart-line": "icon",
    "chart-network": "icon",
    "chart-pie": "icon",
    "chart-scatter": "icon",
    "clipboard-list": "icon",
    "funnel": "icon",
    "gauge": "icon",
    "grid-2x2": "icon",
    "grid-3x3": "icon",
    "layout-dashboard": "icon",
    "layout-grid": "icon",
    "layout-list": "icon",
    "list-filter": "icon",
    "list-tree": "icon",
    "qr-code": "icon",
    "radar": "icon",
    "sigma": "icon",
    "table": "icon",
    "table-cells-merge": "icon",
    "table-cells-split": "icon",
    "trending-down": "icon",
    "trending-up": "icon",
    "file": "icon",
    "file-archive": "icon",
    "file-check": "icon",
    "file-code": "icon",
    "file-image": "icon",
    "file-lock": "icon",
    "file-plus": "icon",
    "file-search": "icon",
    "file-spreadsheet": "icon",
    "file-text": "icon",
    "file-x": "icon",
    "files": "icon",
    "folder": "icon",
    "folder-open": "icon",
    "folder-plus": "icon",
    "folder-tree": "icon",
    "newspaper": "icon",
    "notebook": "icon",
    "presentation": "icon",
    "scroll-text": "icon",
    "sticky-note": "icon",
    "audio-lines": "icon",
    "camera": "icon",
    "camera-off": "icon",
    "captions": "icon",
    "film": "icon",
    "gallery-horizontal": "icon",
    "image": "icon",
    "image-off": "icon",
    "image-plus": "icon",
    "images": "icon",
    "mic": "icon",
    "mic-off": "icon",
    "music": "icon",
    "podcast": "icon",
    "video": "icon",
    "video-off": "icon",
    "circle-pause": "icon",
    "circle-play": "icon",
    "circle-stop": "icon",
    "fast-forward": "icon",
    "pause": "icon",
    "picture-in-picture": "icon",
    "play": "icon",
    "repeat": "icon",
    "rewind": "icon",
    "shuffle": "icon",
    "skip-back": "icon",
    "skip-forward": "icon",
    "volume-high": "icon",
    "volume-low": "icon",
    "volume-x": "icon",
    "a-arrow-down": "icon",
    "a-arrow-up": "icon",
    "a-large-small": "icon",
    "asterisk": "icon",
    "bold": "icon",
    "hash": "icon",
    "heading": "icon",
    "heading-1": "icon",
    "heading-2": "icon",
    "heading-3": "icon",
    "italic": "icon",
    "list": "icon",
    "list-indent-decrease": "icon",
    "list-indent-increase": "icon",
    "list-ordered": "icon",
    "quote": "icon",
    "remove-formatting": "icon",
    "spell-check": "icon",
    "strikethrough": "icon",
    "subscript": "icon",
    "superscript": "icon",
    "table-of-contents": "icon",
    "text-align-center": "icon",
    "text-align-end": "icon",
    "text-align-justify": "icon",
    "text-align-start": "icon",
    "text-quote": "icon",
    "text-select": "icon",
    "type": "icon",
    "underline": "icon",
    "align-center-horizontal": "icon",
    "align-center-vertical": "icon",
    "align-end-horizontal": "icon",
    "align-end-vertical": "icon",
    "align-start-horizontal": "icon",
    "align-start-vertical": "icon",
    "bring-to-front": "icon",
    "columns-2": "icon",
    "columns-3": "icon",
    "crop": "icon",
    "droplet": "icon",
    "eraser": "icon",
    "flip-horizontal": "icon",
    "flip-vertical": "icon",
    "highlighter": "icon",
    "layers": "icon",
    "paint-bucket": "icon",
    "brush": "icon",
    "palette": "icon",
    "eyedropper": "icon",
    "ruler": "icon",
    "send-to-back": "icon",
    "shapes": "icon",
    "signature": "icon",
    "at-sign": "icon",
    "bell": "icon",
    "bell-dot": "icon",
    "bell-off": "icon",
    "bell-ring": "icon",
    "forward": "icon",
    "inbox": "icon",
    "mail": "icon",
    "mail-open": "icon",
    "mail-plus": "icon",
    "megaphone": "icon",
    "chat": "icon",
    "chat-more": "icon",
    "chat-plus": "icon",
    "message-square": "icon",
    "message-square-dot": "icon",
    "message-square-reply": "icon",
    "messages-square": "icon",
    "phone": "icon",
    "phone-call": "icon",
    "phone-missed": "icon",
    "phone-off": "icon",
    "reply": "icon",
    "reply-all": "icon",
    "screen-share": "icon",
    "screen-share-off": "icon",
    "send": "icon",
    "smile": "icon",
    "voicemail": "icon",
    "barcode": "icon",
    "box": "icon",
    "credit-card": "icon",
    "gift": "icon",
    "package": "icon",
    "package-open": "icon",
    "receipt": "icon",
    "shopping-bag": "icon",
    "shopping-cart": "icon",
    "store": "icon",
    "tag": "icon",
    "tags": "icon",
    "ticket": "icon",
    "truck": "icon",
    "alarm-clock": "icon",
    "calendar": "icon",
    "calendar-check": "icon",
    "calendar-clock": "icon",
    "calendar-days": "icon",
    "calendar-plus": "icon",
    "calendar-range": "icon",
    "calendar-x": "icon",
    "clock": "icon",
    "history": "icon",
    "hourglass": "icon",
    "timer": "icon",
    "cookie": "icon",
    "fingerprint": "icon",
    "globe-lock": "icon",
    "key": "icon",
    "lock": "icon",
    "lock-open": "icon",
    "log-in": "icon",
    "log-out": "icon",
    "scan-face": "icon",
    "shield": "icon",
    "shield-alert": "icon",
    "shield-check": "icon",
    "shield-off": "icon",
    "shield-x": "icon",
    "vault": "icon",
    "incognito": "icon",
    "languages": "icon",
    "moon": "icon",
    "settings": "icon",
    "sliders": "icon",
    "sun-moon": "icon",
    "wrench": "icon",
    "building": "icon",
    "kanban": "icon",
    "milestone": "icon",
    "briefcase": "icon",
    "banknote": "icon",
    "circle-dollar-sign": "icon",
    "coins": "icon",
    "dollar-sign": "icon",
    "euro": "icon",
    "landmark": "icon",
    "percent": "icon",
    "scale": "icon",
    "wallet": "icon",
    "car": "icon",
    "hospital": "icon",
    "locate": "icon",
    "locate-fixed": "icon",
    "map": "icon",
    "map-pin": "icon",
    "map-pin-off": "icon",
    "map-pin-plus": "icon",
    "plane": "icon",
    "route": "icon",
    "waypoints": "icon",
    "app-window": "icon",
    "command": "icon",
    "panel-bottom": "icon",
    "panel-bottom-close": "icon",
    "panel-bottom-open": "icon",
    "sidebar": "icon",
    "panel-left-close": "icon",
    "panel-left-open": "icon",
    "panel-right": "icon",
    "panel-right-close": "icon",
    "panel-right-open": "icon",
    "power": "icon",
    "separator-horizontal": "icon",
    "battery": "icon",
    "battery-charging": "icon",
    "battery-full": "icon",
    "battery-low": "icon",
    "battery-medium": "icon",
    "battery-warning": "icon",
    "computer": "icon",
    "cpu": "icon",
    "hard-drive": "icon",
    "headphones": "icon",
    "keyboard": "icon",
    "laptop": "icon",
    "monitor": "icon",
    "monitor-smartphone": "icon",
    "mouse": "icon",
    "printer": "icon",
    "server": "icon",
    "smartphone": "icon",
    "tablet": "icon",
    "tv": "icon",
    "usb": "icon",
    "watch": "icon",
    "webcam": "icon",
    "bluetooth": "icon",
    "bluetooth-off": "icon",
    "cast": "icon",
    "cloud-off": "icon",
    "cloud-sync": "icon",
    "globe": "icon",
    "network": "icon",
    "plug": "icon",
    "radio-tower": "icon",
    "router": "icon",
    "rss": "icon",
    "signal": "icon",
    "unplug": "icon",
    "wifi": "icon",
    "wifi-high": "icon",
    "wifi-low": "icon",
    "wifi-off": "icon",
    "wifi-zero": "icon",
    "braces": "icon",
    "bug": "icon",
    "code": "icon",
    "component": "icon",
    "container": "icon",
    "database": "icon",
    "database-backup": "icon",
    "diff": "icon",
    "git-branch": "icon",
    "git-commit": "icon",
    "git-compare": "icon",
    "git-fork": "icon",
    "git-graph": "icon",
    "git-merge": "icon",
    "git-pull-request": "icon",
    "git-pull-request-closed": "icon",
    "git-pull-request-draft": "icon",
    "logs": "icon",
    "puzzle": "icon",
    "regex": "icon",
    "search-code": "icon",
    "terminal": "icon",
    "variable": "icon",
    "webhook": "icon",
    "workflow": "icon",
    "github": "icon",
    "award": "icon",
    "crown": "icon",
    "dice": "icon",
    "party-popper": "icon",
    "star": "icon",
    "star-half": "icon",
    "trophy": "icon",
    "bot": "icon",
    "brain": "icon",
    "sparkles": "icon",
    "magic-wand": "icon",
    "book": "icon",
    "book-open": "icon",
    "flask": "icon",
    "graduation-cap": "icon",
    "library": "icon",
    "cloud": "icon",
    "cloud-lightning": "icon",
    "cloud-rain": "icon",
    "snowflake": "icon",
    "sun": "icon",
    "thermometer": "icon",
    "wind": "icon",
    "accessibility": "icon",
    "calculator": "icon",
    "circle": "icon",
    "coffee": "icon",
    "copyright": "icon",
    "cross": "icon",
    "hexagon": "icon",
    "infinity": "icon",
    "leaf": "icon",
    "lightbulb": "icon",
    "recycle": "icon",
    "square": "icon",
    "target-icon": "icon",
    "triangle": "icon",
    "down": "icon",
    "arrow-downward": "icon",
    "move-down": "icon",
    "left": "icon",
    "back": "icon",
    "arrow-back": "icon",
    "previous": "icon",
    "horizontal": "icon",
    "resize-horizontal": "icon",
    "swap-horizontal": "icon",
    "swap-horiz": "icon",
    "arrows-horizontal": "icon",
    "bidirectional": "icon",
    "right": "icon",
    "arrow-forward": "icon",
    "next": "icon",
    "go-right": "icon",
    "up": "icon",
    "arrow-upward": "icon",
    "move-up": "icon",
    "vertical": "icon",
    "resize-vertical": "icon",
    "swap-vertical": "icon",
    "swap-vert": "icon",
    "arrows-vertical": "icon",
    "caret-down": "icon",
    "dropdown": "icon",
    "arrow-drop-down": "icon",
    "select-arrow": "icon",
    "collapse-down": "icon",
    "angle-down": "icon",
    "skip-to-start": "icon",
    "first-page": "icon",
    "page-first": "icon",
    "go-to-first": "icon",
    "chevron-double-left": "icon",
    "step-first": "icon",
    "skip-to-end": "icon",
    "last-page": "icon",
    "page-last": "icon",
    "go-to-last": "icon",
    "chevron-double-right": "icon",
    "step-last": "icon",
    "caret-left": "icon",
    "collapse-left": "icon",
    "nav-left": "icon",
    "angle-left": "icon",
    "caret-right": "icon",
    "expand-right": "icon",
    "nav-right": "icon",
    "angle-right": "icon",
    "caret-up": "icon",
    "collapse": "icon",
    "collapse-up": "icon",
    "angle-up": "icon",
    "collapse-vertical": "icon",
    "unfold-less": "icon",
    "collapse-all": "icon",
    "fold": "icon",
    "expand-horizontal": "icon",
    "unfold-horizontal": "icon",
    "expand-width": "icon",
    "expand-vertical": "icon",
    "unfold-more": "icon",
    "sort-indicator": "icon",
    "selector": "icon",
    "select": "icon",
    "caret-up-down": "icon",
    "unfold": "icon",
    "explore": "icon",
    "direction": "icon",
    "navigate": "icon",
    "discover": "icon",
    "safari": "icon",
    "return-key": "icon",
    "enter": "icon",
    "subdirectory-left": "icon",
    "arrow-bend-down-left": "icon",
    "carriage-return": "icon",
    "subdirectory-right": "icon",
    "arrow-bend-down-right": "icon",
    "forward-down": "icon",
    "target-location": "icon",
    "aim": "icon",
    "gps": "icon",
    "location-searching": "icon",
    "viewfinder": "icon",
    "scope": "icon",
    "square-arrow-out-up-right": "icon",
    "open-in-new": "icon",
    "new-window": "icon",
    "new-tab": "icon",
    "launch": "icon",
    "arrow-square-out": "icon",
    "outbound": "icon",
    "open-external": "icon",
    "house": "icon",
    "homepage": "icon",
    "main": "icon",
    "sidebar-left": "icon",
    "layout-sidebar": "icon",
    "view-sidebar": "icon",
    "side-panel": "icon",
    "navbar": "icon",
    "layout-navbar": "icon",
    "header-panel": "icon",
    "top-bar": "icon",
    "web-asset": "icon",
    "hamburger": "icon",
    "hamburger-menu": "icon",
    "bars-3": "icon",
    "navigation-menu": "icon",
    "nav-menu": "icon",
    "cursor": "icon",
    "pointer": "icon",
    "arrow-cursor": "icon",
    "cursor-arrow": "icon",
    "arrow-selector": "icon",
    "archive-box": "icon",
    "file-away": "icon",
    "put-away": "icon",
    "unarchive": "icon",
    "restore": "icon",
    "archive-undo": "icon",
    "archive-remove": "icon",
    "archive-delete": "icon",
    "archive-off": "icon",
    "sort-alpha-asc": "icon",
    "sort-ascending": "icon",
    "sort-alpha-down": "icon",
    "sort-az": "icon",
    "sort-alphabetical": "icon",
    "sort-alpha-desc": "icon",
    "sort-descending": "icon",
    "sort-alpha-up": "icon",
    "sort-za": "icon",
    "sort-alphabetical-reverse": "icon",
    "save-for-later": "icon",
    "saved": "icon",
    "flag-bookmark": "icon",
    "reading-list": "icon",
    "bookmark-saved": "icon",
    "bookmark-done": "icon",
    "bookmark-confirmed": "icon",
    "bookmark-add": "icon",
    "add-bookmark": "icon",
    "bookmark-new": "icon",
    "more-circle": "icon",
    "dots-circle": "icon",
    "pending-actions": "icon",
    "options-circle": "icon",
    "remove-circle": "icon",
    "subtract-circle": "icon",
    "minus-circle": "icon",
    "add-circle": "icon",
    "create-circle": "icon",
    "plus-circle": "icon",
    "new-circle": "icon",
    "cancel": "icon",
    "close-circle": "icon",
    "dismiss": "icon",
    "x-circle": "icon",
    "paste-board": "icon",
    "assignment": "icon",
    "copy-board": "icon",
    "paste": "icon",
    "content-paste": "icon",
    "paste-from-clipboard": "icon",
    "download-cloud": "icon",
    "cloud-save": "icon",
    "cloud-arrow-down": "icon",
    "upload-cloud": "icon",
    "cloud-push": "icon",
    "cloud-arrow-up": "icon",
    "duplicate": "icon",
    "clone": "icon",
    "content-copy": "icon",
    "copy-to-clipboard": "icon",
    "copied": "icon",
    "copy-success": "icon",
    "clipboard-check": "icon",
    "copy-confirmed": "icon",
    "back-delete": "icon",
    "erase-back": "icon",
    "remove-character": "icon",
    "download-file": "icon",
    "export": "icon",
    "arrow-down-tray": "icon",
    "more": "icon",
    "dots": "icon",
    "three-dots": "icon",
    "more-horizontal": "icon",
    "kebab-horizontal": "icon",
    "options": "icon",
    "more-vertical": "icon",
    "dots-vertical": "icon",
    "three-dots-vertical": "icon",
    "kebab-menu": "icon",
    "kebab": "icon",
    "options-vertical": "icon",
    "fullscreen": "icon",
    "enlarge": "icon",
    "arrows-out": "icon",
    "open-in-full": "icon",
    "grow": "icon",
    "view": "icon",
    "visible": "icon",
    "show": "icon",
    "visibility": "icon",
    "preview": "icon",
    "hidden": "icon",
    "hide": "icon",
    "invisible": "icon",
    "visibility-off": "icon",
    "eye-slash": "icon",
    "conceal": "icon",
    "drag-handle": "icon",
    "drag-horizontal": "icon",
    "dots-six": "icon",
    "handle-horizontal": "icon",
    "reorder": "icon",
    "drag-indicator": "icon",
    "drag-vertical": "icon",
    "dots-six-vertical": "icon",
    "handle-vertical": "icon",
    "stop": "icon",
    "hand-stop": "icon",
    "hand-raised": "icon",
    "raise-hand": "icon",
    "pan-tool": "icon",
    "halt": "icon",
    "like": "icon",
    "love": "icon",
    "favorite": "icon",
    "favourite": "icon",
    "unlike": "icon",
    "heart-broken": "icon",
    "unfavorite": "icon",
    "dislike": "icon",
    "heart-break": "icon",
    "hyperlink": "icon",
    "url": "icon",
    "chain": "icon",
    "anchor": "icon",
    "list-check": "icon",
    "completed-tasks": "icon",
    "expand-full": "icon",
    "arrows-maximize": "icon",
    "combine": "icon",
    "join": "icon",
    "arrows-merge": "icon",
    "converge": "icon",
    "exit-fullscreen": "icon",
    "shrink": "icon",
    "collapse-full": "icon",
    "arrows-minimize": "icon",
    "arrows-in": "icon",
    "reduce": "icon",
    "subtract": "icon",
    "dash": "icon",
    "cursor-click": "icon",
    "click": "icon",
    "tap": "icon",
    "pointer-click": "icon",
    "ads-click": "icon",
    "drag": "icon",
    "reposition": "icon",
    "arrows-move": "icon",
    "open-with": "icon",
    "arrows-out-cardinal": "icon",
    "rearrange": "icon",
    "attach": "icon",
    "attachment": "icon",
    "attach-file": "icon",
    "paper-clip": "icon",
    "clip": "icon",
    "edit": "icon",
    "modify": "icon",
    "write": "icon",
    "pen": "icon",
    "push-pin": "icon",
    "pinned": "icon",
    "thumbtack": "icon",
    "keep": "icon",
    "tack": "icon",
    "unpin": "icon",
    "pinned-off": "icon",
    "remove-pin": "icon",
    "keep-off": "icon",
    "add": "icon",
    "create": "icon",
    "new": "icon",
    "insert": "icon",
    "redo-action": "icon",
    "arrow-clockwise": "icon",
    "step-forward": "icon",
    "refresh-ccw": "icon",
    "reload": "icon",
    "sync": "icon",
    "update": "icon",
    "retry": "icon",
    "find-replace": "icon",
    "swap": "icon",
    "substitute": "icon",
    "search-replace": "icon",
    "find-and-replace": "icon",
    "deploy": "icon",
    "liftoff": "icon",
    "rocket-launch": "icon",
    "blast-off": "icon",
    "ship-it": "icon",
    "rotate-left": "icon",
    "rotate-counter-clockwise": "icon",
    "turn-left": "icon",
    "rotate-right": "icon",
    "rotate-clockwise": "icon",
    "turn-right": "icon",
    "floppy-disk": "icon",
    "floppy": "icon",
    "persist": "icon",
    "save-file": "icon",
    "device-floppy": "icon",
    "crop-free": "icon",
    "camera-scan": "icon",
    "viewfinder-circle": "icon",
    "cut": "icon",
    "content-cut": "icon",
    "snip": "icon",
    "clip-content": "icon",
    "find": "icon",
    "magnifying-glass": "icon",
    "lookup": "icon",
    "look-up": "icon",
    "share-link": "icon",
    "distribute": "icon",
    "spread": "icon",
    "share-network": "icon",
    "divide": "icon",
    "fork-vertical": "icon",
    "call-split": "icon",
    "downvote": "icon",
    "thumb-down": "icon",
    "reject": "icon",
    "disapprove": "icon",
    "upvote": "icon",
    "thumb-up": "icon",
    "approve": "icon",
    "recommend": "icon",
    "delete": "icon",
    "bin": "icon",
    "garbage": "icon",
    "discard": "icon",
    "revert": "icon",
    "undo-action": "icon",
    "arrow-counter-clockwise": "icon",
    "go-back": "icon",
    "step-back": "icon",
    "link-break": "icon",
    "remove-link": "icon",
    "disconnect-link": "icon",
    "link-off": "icon",
    "chain-break": "icon",
    "publish": "icon",
    "export-file": "icon",
    "arrow-up-tray": "icon",
    "upload-file": "icon",
    "ballot": "icon",
    "poll": "icon",
    "election": "icon",
    "how-to-vote": "icon",
    "cast-vote": "icon",
    "close": "icon",
    "remove": "icon",
    "magnify": "icon",
    "zoom-plus": "icon",
    "magnifying-glass-plus": "icon",
    "scale-up": "icon",
    "badge-warning": "icon",
    "seal-warning": "icon",
    "badge-exclamation": "icon",
    "verified-warning": "icon",
    "verified": "icon",
    "certified": "icon",
    "seal-check": "icon",
    "badge-verified": "icon",
    "rosette": "icon",
    "badge-question": "icon",
    "seal-info": "icon",
    "badge-information": "icon",
    "block": "icon",
    "prohibit": "icon",
    "forbidden": "icon",
    "no-entry": "icon",
    "restricted": "icon",
    "no-symbol": "icon",
    "done": "icon",
    "confirm": "icon",
    "checkmark": "icon",
    "tick": "icon",
    "complete": "icon",
    "yes": "icon",
    "ok": "icon",
    "double-check": "icon",
    "read-receipt": "icon",
    "done-all": "icon",
    "all-done": "icon",
    "verified-check": "icon",
    "circle-alert": "icon",
    "error-circle": "icon",
    "warning-circle": "icon",
    "alert-circle": "icon",
    "exclamation-circle": "icon",
    "circle-exclamation": "icon",
    "circle-warning": "icon",
    "success": "icon",
    "check-circle": "icon",
    "complete-circle": "icon",
    "done-circle": "icon",
    "approved": "icon",
    "circle-success": "icon",
    "pending": "icon",
    "in-progress": "icon",
    "loading-circle": "icon",
    "incomplete": "icon",
    "circle-question-mark": "icon",
    "help-circle": "icon",
    "faq": "icon",
    "question": "icon",
    "question-circle": "icon",
    "support": "icon",
    "under-construction": "icon",
    "maintenance": "icon",
    "roadblock": "icon",
    "barricade": "icon",
    "wip": "icon",
    "report": "icon",
    "flag-report": "icon",
    "flagged": "icon",
    "mark": "icon",
    "banner": "icon",
    "fire": "icon",
    "hot": "icon",
    "popular": "icon",
    "burn": "icon",
    "lit": "icon",
    "sad": "icon",
    "unhappy": "icon",
    "dissatisfied": "icon",
    "negative": "icon",
    "sad-face": "icon",
    "emoji-sad": "icon",
    "information": "icon",
    "info-circle": "icon",
    "information-circle": "icon",
    "about": "icon",
    "details": "icon",
    "lifebuoy": "icon",
    "rescue": "icon",
    "life-ring": "icon",
    "spinner": "icon",
    "spinner-gap": "icon",
    "autorenew": "icon",
    "busy": "icon",
    "spinner-circle": "icon",
    "progress-activity": "icon",
    "buffering": "icon",
    "neutral": "icon",
    "indifferent": "icon",
    "smiley-meh": "icon",
    "sentiment-neutral": "icon",
    "expressionless": "icon",
    "server-error": "icon",
    "server-down": "icon",
    "server-off": "icon",
    "server-failure": "icon",
    "outage": "icon",
    "triangle-alert": "icon",
    "caution": "icon",
    "alert-triangle": "icon",
    "danger": "icon",
    "exclamation-triangle": "icon",
    "zap": "icon",
    "lightning": "icon",
    "flash": "icon",
    "electric": "icon",
    "instant": "icon",
    "circle-user": "icon",
    "user-circle": "icon",
    "account-circle": "icon",
    "profile": "icon",
    "user-avatar": "icon",
    "address-book": "icon",
    "contact-card": "icon",
    "vcard": "icon",
    "person-details": "icon",
    "identification": "icon",
    "badge": "icon",
    "identity-card": "icon",
    "id": "icon",
    "name-badge": "icon",
    "credentials": "icon",
    "person": "icon",
    "account": "icon",
    "member": "icon",
    "user-verified": "icon",
    "user-approved": "icon",
    "person-check": "icon",
    "how-to-reg": "icon",
    "user-confirm": "icon",
    "user-settings": "icon",
    "user-preferences": "icon",
    "manage-accounts": "icon",
    "user-gear": "icon",
    "user-config": "icon",
    "remove-user": "icon",
    "unfriend": "icon",
    "person-remove": "icon",
    "user-remove": "icon",
    "add-user": "icon",
    "new-user": "icon",
    "person-add": "icon",
    "user-add": "icon",
    "invite-user": "icon",
    "find-user": "icon",
    "person-search": "icon",
    "lookup-user": "icon",
    "user-find": "icon",
    "block-user": "icon",
    "ban-user": "icon",
    "person-off": "icon",
    "user-block": "icon",
    "user-reject": "icon",
    "group": "icon",
    "team": "icon",
    "people": "icon",
    "members": "icon",
    "community": "icon",
    "radio-button": "icon",
    "radio": "icon",
    "record": "icon",
    "bullseye": "icon",
    "selected": "icon",
    "rectangle-ellipsis": "icon",
    "password-field": "icon",
    "hidden-input": "icon",
    "password-input": "icon",
    "dots-input": "icon",
    "checkbox": "icon",
    "checkbox-checked": "icon",
    "check-box": "icon",
    "check-square": "icon",
    "task-done": "icon",
    "text-input": "icon",
    "cursor-text": "icon",
    "input-cursor": "icon",
    "text-field": "icon",
    "toggle-off": "icon",
    "toggle-inactive": "icon",
    "toggle-on": "icon",
    "switch-on": "icon",
    "toggle-active": "icon",
    "pulse": "icon",
    "heartbeat": "icon",
    "heart-rate": "icon",
    "vital-signs": "icon",
    "monitoring": "icon",
    "area-chart": "icon",
    "graph-area": "icon",
    "chart-area-line": "icon",
    "bar-chart": "icon",
    "graph-bar": "icon",
    "bar-graph": "icon",
    "histogram": "icon",
    "analytics": "icon",
    "stacked-bar": "icon",
    "stacked-chart": "icon",
    "stacked-bar-chart": "icon",
    "candlestick": "icon",
    "stock-chart": "icon",
    "financial-chart": "icon",
    "ohlc": "icon",
    "gantt": "icon",
    "timeline-chart": "icon",
    "project-timeline": "icon",
    "project-chart": "icon",
    "line-chart": "icon",
    "graph-line": "icon",
    "line-graph": "icon",
    "trend": "icon",
    "show-chart": "icon",
    "graph": "icon",
    "network-graph": "icon",
    "graph-network": "icon",
    "topology": "icon",
    "node-graph": "icon",
    "relationship-graph": "icon",
    "mind-map": "icon",
    "pie-chart": "icon",
    "donut-chart": "icon",
    "graph-pie": "icon",
    "pie-graph": "icon",
    "scatter-plot": "icon",
    "dot-plot": "icon",
    "scatter-chart": "icon",
    "data-points": "icon",
    "task-list": "icon",
    "checklist": "icon",
    "todo-list": "icon",
    "assignment-list": "icon",
    "filter": "icon",
    "filter-list": "icon",
    "sort-funnel": "icon",
    "filter-alt": "icon",
    "sieve": "icon",
    "speedometer": "icon",
    "performance": "icon",
    "speed": "icon",
    "meter": "icon",
    "dashboard-gauge": "icon",
    "tachometer": "icon",
    "grid-four": "icon",
    "grid-view": "icon",
    "squares-2x2": "icon",
    "grid-small": "icon",
    "grid-nine": "icon",
    "grid-large": "icon",
    "dashboard": "icon",
    "widgets": "icon",
    "dashboard-layout": "icon",
    "rectangle-group": "icon",
    "apps": "icon",
    "grid-layout": "icon",
    "app-grid": "icon",
    "list-view": "icon",
    "view-list": "icon",
    "queue-list": "icon",
    "sort-filter": "icon",
    "tree-view": "icon",
    "nested-list": "icon",
    "qrcode": "icon",
    "barcode-2d": "icon",
    "chart-polar": "icon",
    "sonar": "icon",
    "detection": "icon",
    "sweep": "icon",
    "sum": "icon",
    "summation": "icon",
    "aggregate": "icon",
    "total": "icon",
    "math-sigma": "icon",
    "data-table": "icon",
    "grid": "icon",
    "data-grid": "icon",
    "merge-cells": "icon",
    "cell-merge": "icon",
    "combine-cells": "icon",
    "split-cells": "icon",
    "cell-split": "icon",
    "unmerge-cells": "icon",
    "trend-down": "icon",
    "decrease": "icon",
    "decline": "icon",
    "arrow-trending-down": "icon",
    "downtrend": "icon",
    "trend-up": "icon",
    "increase": "icon",
    "growth": "icon",
    "arrow-trending-up": "icon",
    "uptrend": "icon",
    "document": "icon",
    "page": "icon",
    "doc": "icon",
    "draft": "icon",
    "zip": "icon",
    "compressed": "icon",
    "archive-file": "icon",
    "file-zip": "icon",
    "rar": "icon",
    "file-verified": "icon",
    "file-approved": "icon",
    "file-done": "icon",
    "document-check": "icon",
    "source-file": "icon",
    "code-file": "icon",
    "script": "icon",
    "integration-instructions": "icon",
    "image-file": "icon",
    "photo-file": "icon",
    "picture-file": "icon",
    "media-file": "icon",
    "file-protected": "icon",
    "file-encrypted": "icon",
    "secure-file": "icon",
    "file-shield": "icon",
    "new-file": "icon",
    "create-file": "icon",
    "add-file": "icon",
    "file-add": "icon",
    "note-add": "icon",
    "find-in-file": "icon",
    "search-file": "icon",
    "file-find": "icon",
    "find-in-page": "icon",
    "excel": "icon",
    "csv": "icon",
    "file-xls": "icon",
    "spreadsheet": "icon",
    "file-table": "icon",
    "text-file": "icon",
    "document-text": "icon",
    "readme": "icon",
    "description": "icon",
    "file-document": "icon",
    "file-remove": "icon",
    "file-delete": "icon",
    "file-reject": "icon",
    "remove-file": "icon",
    "documents": "icon",
    "multiple-files": "icon",
    "file-copy": "icon",
    "file-stack": "icon",
    "directory": "icon",
    "dir": "icon",
    "open-folder": "icon",
    "folder-opened": "icon",
    "directory-open": "icon",
    "new-folder": "icon",
    "create-folder": "icon",
    "add-folder": "icon",
    "folder-add": "icon",
    "directory-tree": "icon",
    "file-tree": "icon",
    "folder-structure": "icon",
    "sitemap": "icon",
    "hierarchy": "icon",
    "account-tree": "icon",
    "news": "icon",
    "article": "icon",
    "press": "icon",
    "publication": "icon",
    "headline": "icon",
    "journal": "icon",
    "diary": "icon",
    "notepad": "icon",
    "menu-book": "icon",
    "slides": "icon",
    "keynote": "icon",
    "pitch-deck": "icon",
    "terms": "icon",
    "legal-document": "icon",
    "terms-of-service": "icon",
    "scroll": "icon",
    "manuscript": "icon",
    "note": "icon",
    "memo": "icon",
    "post-it": "icon",
    "reminder-note": "icon",
    "waveform": "icon",
    "sound-wave": "icon",
    "equalizer": "icon",
    "audio-wave": "icon",
    "graphic-eq": "icon",
    "spectrum": "icon",
    "photo": "icon",
    "take-photo": "icon",
    "snapshot": "icon",
    "capture": "icon",
    "photography": "icon",
    "photo-camera": "icon",
    "no-camera": "icon",
    "camera-disabled": "icon",
    "camera-slash": "icon",
    "no-photography": "icon",
    "subtitles": "icon",
    "closed-captions": "icon",
    "cc": "icon",
    "closed-captioning": "icon",
    "subtitle": "icon",
    "movie": "icon",
    "video-film": "icon",
    "cinema": "icon",
    "reel": "icon",
    "film-strip": "icon",
    "carousel": "icon",
    "image-gallery": "icon",
    "slideshow": "icon",
    "photo-gallery": "icon",
    "view-carousel": "icon",
    "picture": "icon",
    "img": "icon",
    "photograph": "icon",
    "image-broken": "icon",
    "photo-off": "icon",
    "broken-image": "icon",
    "hide-image": "icon",
    "no-image": "icon",
    "add-photo": "icon",
    "photo-plus": "icon",
    "add-image": "icon",
    "camera-plus": "icon",
    "upload-image": "icon",
    "gallery": "icon",
    "photo-library": "icon",
    "photo-album": "icon",
    "photos": "icon",
    "library-photo": "icon",
    "microphone": "icon",
    "record-audio": "icon",
    "voice": "icon",
    "mute": "icon",
    "microphone-off": "icon",
    "muted": "icon",
    "mic-mute": "icon",
    "microphone-slash": "icon",
    "song": "icon",
    "music-note": "icon",
    "musical-note": "icon",
    "tune": "icon",
    "audio-show": "icon",
    "podcasts": "icon",
    "radio-show": "icon",
    "camera-video": "icon",
    "videocam": "icon",
    "video-camera": "icon",
    "record-video": "icon",
    "cam": "icon",
    "camera-off-video": "icon",
    "videocam-off": "icon",
    "video-disabled": "icon",
    "video-camera-slash": "icon",
    "no-video": "icon",
    "pause-circle": "icon",
    "pause-button": "icon",
    "play-circle": "icon",
    "play-button": "icon",
    "stop-circle": "icon",
    "stop-button": "icon",
    "skip-ahead": "icon",
    "speed-up": "icon",
    "ff": "icon",
    "next-track": "icon",
    "hold": "icon",
    "player-pause": "icon",
    "pause-playback": "icon",
    "pip": "icon",
    "floating-video": "icon",
    "mini-player": "icon",
    "start": "icon",
    "resume": "icon",
    "play-arrow": "icon",
    "player-play": "icon",
    "loop": "icon",
    "repeat-playback": "icon",
    "cycle": "icon",
    "fast-rewind": "icon",
    "skip-backward": "icon",
    "backward": "icon",
    "player-track-prev": "icon",
    "randomize": "icon",
    "mix": "icon",
    "arrows-shuffle": "icon",
    "previous-track": "icon",
    "skip-previous": "icon",
    "step-backward": "icon",
    "player-skip-back": "icon",
    "skip-next": "icon",
    "player-skip-forward": "icon",
    "volume-2": "icon",
    "volume-up": "icon",
    "speaker": "icon",
    "speaker-high": "icon",
    "sound": "icon",
    "volume-down": "icon",
    "volume-1": "icon",
    "speaker-low": "icon",
    "quiet": "icon",
    "low-volume": "icon",
    "volume-mute": "icon",
    "volume-off": "icon",
    "speaker-mute": "icon",
    "sound-off": "icon",
    "speaker-x-mark": "icon",
    "no-sound": "icon",
    "font-size-decrease": "icon",
    "text-decrease": "icon",
    "font-decrease": "icon",
    "text-smaller": "icon",
    "font-size-increase": "icon",
    "text-increase": "icon",
    "font-increase": "icon",
    "text-larger": "icon",
    "font-size": "icon",
    "text-resize": "icon",
    "format-size": "icon",
    "text-size": "icon",
    "required": "icon",
    "star-small": "icon",
    "wildcard": "icon",
    "footnote": "icon",
    "text-bold": "icon",
    "format-bold": "icon",
    "strong": "icon",
    "hashtag": "icon",
    "number-sign": "icon",
    "pound": "icon",
    "title": "icon",
    "text-h": "icon",
    "h1": "icon",
    "h2": "icon",
    "h3": "icon",
    "format-italic": "icon",
    "text-italic": "icon",
    "emphasis": "icon",
    "unordered-list": "icon",
    "bullet-list": "icon",
    "list-bullet": "icon",
    "list-ul": "icon",
    "format-list-bulleted": "icon",
    "outdent": "icon",
    "indent-decrease": "icon",
    "text-outdent": "icon",
    "dedent": "icon",
    "indent": "icon",
    "indent-increase": "icon",
    "text-indent": "icon",
    "tab": "icon",
    "numbered-list": "icon",
    "list-numbers": "icon",
    "list-ol": "icon",
    "format-list-numbered": "icon",
    "ordered-list": "icon",
    "blockquote": "icon",
    "citation": "icon",
    "quotes": "icon",
    "format-quote": "icon",
    "quotation": "icon",
    "clear-formatting": "icon",
    "format-clear": "icon",
    "strip-formatting": "icon",
    "plain-text": "icon",
    "spellcheck": "icon",
    "grammar": "icon",
    "proofread": "icon",
    "abc-check": "icon",
    "line-through": "icon",
    "text-strikethrough": "icon",
    "format-strikethrough": "icon",
    "crossed-out": "icon",
    "text-subscript": "icon",
    "format-subscript": "icon",
    "sub": "icon",
    "text-superscript": "icon",
    "format-superscript": "icon",
    "sup": "icon",
    "toc": "icon",
    "index": "icon",
    "outline": "icon",
    "page-index": "icon",
    "align-center": "icon",
    "center-align": "icon",
    "format-align-center": "icon",
    "align-right": "icon",
    "right-align": "icon",
    "text-align-right": "icon",
    "format-align-right": "icon",
    "justify": "icon",
    "align-justify": "icon",
    "format-align-justify": "icon",
    "align-left": "icon",
    "left-align": "icon",
    "text-align-left": "icon",
    "format-align-left": "icon",
    "quote-block": "icon",
    "pull-quote": "icon",
    "select-text": "icon",
    "text-selection": "icon",
    "highlight-text": "icon",
    "selection": "icon",
    "select-all": "icon",
    "typography": "icon",
    "font": "icon",
    "text-format": "icon",
    "text-fields": "icon",
    "typeface": "icon",
    "text-underline": "icon",
    "format-underline": "icon",
    "format-underlined": "icon",
    "align-horizontal-center": "icon",
    "center-horizontal": "icon",
    "align-vertical-center": "icon",
    "center-vertical": "icon",
    "align-horizontal-right": "icon",
    "align-right-horizontal": "icon",
    "align-bottom-horizontal": "icon",
    "align-vertical-bottom": "icon",
    "align-bottom-vertical": "icon",
    "align-right-vertical": "icon",
    "align-horizontal-left": "icon",
    "align-left-horizontal": "icon",
    "align-top-horizontal": "icon",
    "align-vertical-top": "icon",
    "align-top-vertical": "icon",
    "align-left-vertical": "icon",
    "layer-front": "icon",
    "move-front": "icon",
    "foreground": "icon",
    "stack-front": "icon",
    "flip-to-front": "icon",
    "two-columns": "icon",
    "split-view": "icon",
    "dual-pane": "icon",
    "view-column": "icon",
    "three-columns": "icon",
    "triple-pane": "icon",
    "multi-column": "icon",
    "trim": "icon",
    "crop-image": "icon",
    "resize-crop": "icon",
    "water": "icon",
    "drop": "icon",
    "color-drop": "icon",
    "water-drop": "icon",
    "liquid": "icon",
    "ink": "icon",
    "clear": "icon",
    "erase": "icon",
    "rubber": "icon",
    "wipe": "icon",
    "mirror-horizontal": "icon",
    "reflect-horizontal": "icon",
    "mirror-vertical": "icon",
    "reflect-vertical": "icon",
    "highlight": "icon",
    "marker": "icon",
    "ink-highlighter": "icon",
    "text-highlight": "icon",
    "stack": "icon",
    "stacked": "icon",
    "depth": "icon",
    "rectangle-stack": "icon",
    "overlay": "icon",
    "fill": "icon",
    "color-fill": "icon",
    "flood-fill": "icon",
    "format-color-fill": "icon",
    "paintbrush": "icon",
    "paint": "icon",
    "draw": "icon",
    "color-palette": "icon",
    "swatch": "icon",
    "theme": "icon",
    "colors": "icon",
    "pipette": "icon",
    "color-picker": "icon",
    "colorize": "icon",
    "eye-dropper": "icon",
    "color-sample": "icon",
    "measure": "icon",
    "dimensions": "icon",
    "straighten": "icon",
    "measurement": "icon",
    "move-back": "icon",
    "layer-back": "icon",
    "stack-back": "icon",
    "flip-to-back": "icon",
    "behind": "icon",
    "geometry": "icon",
    "design-elements": "icon",
    "primitives": "icon",
    "autograph": "icon",
    "sign": "icon",
    "handwriting": "icon",
    "at": "icon",
    "mention": "icon",
    "email-at": "icon",
    "at-symbol": "icon",
    "notification": "icon",
    "alert": "icon",
    "notifications": "icon",
    "reminder-bell": "icon",
    "notification-badge": "icon",
    "notification-unread": "icon",
    "bell-badge": "icon",
    "bell-alert": "icon",
    "notification-new": "icon",
    "bell-important": "icon",
    "notification-off": "icon",
    "mute-notification": "icon",
    "bell-mute": "icon",
    "bell-slash": "icon",
    "notifications-off": "icon",
    "do-not-disturb": "icon",
    "notification-active": "icon",
    "bell-ringing": "icon",
    "bell-active": "icon",
    "notifications-active": "icon",
    "ringing": "icon",
    "forward-message": "icon",
    "send-forward": "icon",
    "share-forward": "icon",
    "tray": "icon",
    "mailbox": "icon",
    "email": "icon",
    "envelope": "icon",
    "letter": "icon",
    "e-mail": "icon",
    "email-open": "icon",
    "envelope-open": "icon",
    "read-mail": "icon",
    "mail-opened": "icon",
    "drafts": "icon",
    "compose": "icon",
    "new-email": "icon",
    "new-mail": "icon",
    "write-email": "icon",
    "outgoing-mail": "icon",
    "announcement": "icon",
    "broadcast": "icon",
    "campaign": "icon",
    "speakerphone": "icon",
    "bullhorn": "icon",
    "promote": "icon",
    "message-circle": "icon",
    "chat-bubble": "icon",
    "conversation": "icon",
    "chat-circle": "icon",
    "comment-circle": "icon",
    "bubble": "icon",
    "message-circle-more": "icon",
    "chat-dots": "icon",
    "chat-typing": "icon",
    "message-dots": "icon",
    "chat-loading": "icon",
    "message-circle-plus": "icon",
    "new-chat": "icon",
    "add-comment": "icon",
    "new-conversation": "icon",
    "start-chat": "icon",
    "comment": "icon",
    "chat-square": "icon",
    "message": "icon",
    "speech-bubble": "icon",
    "chat-bubble-left": "icon",
    "unread-message": "icon",
    "new-message": "icon",
    "chat-notification": "icon",
    "mark-chat-unread": "icon",
    "reply-message": "icon",
    "message-reply": "icon",
    "quick-reply": "icon",
    "respond": "icon",
    "forum": "icon",
    "conversation-thread": "icon",
    "chats": "icon",
    "discussion": "icon",
    "chat-thread": "icon",
    "call": "icon",
    "telephone": "icon",
    "dial": "icon",
    "handset": "icon",
    "incoming-call": "icon",
    "phone-ringing": "icon",
    "active-call": "icon",
    "phone-in-talk": "icon",
    "missed-call": "icon",
    "phone-x": "icon",
    "phone-disabled": "icon",
    "end-call": "icon",
    "hangup": "icon",
    "phone-slash": "icon",
    "no-phone": "icon",
    "write-back": "icon",
    "arrow-reply": "icon",
    "respond-all": "icon",
    "reply-to-all": "icon",
    "present-screen": "icon",
    "share-display": "icon",
    "cast-screen": "icon",
    "stop-screenshare": "icon",
    "stop-screen-share": "icon",
    "end-presentation": "icon",
    "screencast-off": "icon",
    "submit": "icon",
    "paper-plane": "icon",
    "dispatch": "icon",
    "paper-airplane": "icon",
    "smiley": "icon",
    "happy": "icon",
    "emoji": "icon",
    "face-smile": "icon",
    "mood-happy": "icon",
    "sentiment-satisfied": "icon",
    "voice-message": "icon",
    "answering-machine": "icon",
    "phone-voicemail": "icon",
    "upc": "icon",
    "product-code": "icon",
    "scan-code": "icon",
    "cube": "icon",
    "crate": "icon",
    "parcel": "icon",
    "carton": "icon",
    "inventory": "icon",
    "card": "icon",
    "debit-card": "icon",
    "pay": "icon",
    "billing": "icon",
    "present": "icon",
    "reward": "icon",
    "redeem": "icon",
    "giveaway": "icon",
    "shipment": "icon",
    "box-sealed": "icon",
    "delivery": "icon",
    "bundle": "icon",
    "unbox": "icon",
    "unboxing": "icon",
    "package-unpack": "icon",
    "cube-transparent": "icon",
    "invoice": "icon",
    "receipt-text": "icon",
    "transaction": "icon",
    "receipt-percent": "icon",
    "bag": "icon",
    "purchase-bag": "icon",
    "store-bag": "icon",
    "retail-bag": "icon",
    "cart": "icon",
    "basket": "icon",
    "checkout": "icon",
    "trolley": "icon",
    "add-to-cart": "icon",
    "shop": "icon",
    "storefront": "icon",
    "retail": "icon",
    "marketplace": "icon",
    "building-store": "icon",
    "label": "icon",
    "price-tag": "icon",
    "sell": "icon",
    "badge-tag": "icon",
    "labels": "icon",
    "multi-tag": "icon",
    "price-tags": "icon",
    "coupon": "icon",
    "admission": "icon",
    "pass": "icon",
    "confirmation-number": "icon",
    "voucher": "icon",
    "shipping": "icon",
    "freight": "icon",
    "local-shipping": "icon",
    "transport": "icon",
    "alarm": "icon",
    "reminder": "icon",
    "wake-up": "icon",
    "timer-alert": "icon",
    "date": "icon",
    "schedule": "icon",
    "datepicker": "icon",
    "date-picker": "icon",
    "calendar-today": "icon",
    "event-confirmed": "icon",
    "date-confirmed": "icon",
    "calendar-done": "icon",
    "event-available": "icon",
    "calendar-confirmed": "icon",
    "schedule-time": "icon",
    "event-time": "icon",
    "calendar-time": "icon",
    "date-time": "icon",
    "appointment": "icon",
    "calendar-month": "icon",
    "calendar-event": "icon",
    "date-range-view": "icon",
    "monthly-view": "icon",
    "add-event": "icon",
    "new-event": "icon",
    "calendar-add": "icon",
    "schedule-new": "icon",
    "create-event": "icon",
    "date-range": "icon",
    "date-span": "icon",
    "calendar-period": "icon",
    "date-picker-range": "icon",
    "cancel-event": "icon",
    "remove-event": "icon",
    "calendar-cancel": "icon",
    "event-busy": "icon",
    "calendar-delete": "icon",
    "time": "icon",
    "hour": "icon",
    "oclock": "icon",
    "recent": "icon",
    "clock-history": "icon",
    "time-past": "icon",
    "activity-log": "icon",
    "timer-sand": "icon",
    "waiting": "icon",
    "sandglass": "icon",
    "hourglass-empty": "icon",
    "stopwatch": "icon",
    "countdown": "icon",
    "elapsed": "icon",
    "time-elapsed": "icon",
    "consent": "icon",
    "browser-cookie": "icon",
    "biscuit": "icon",
    "gdpr": "icon",
    "biometric": "icon",
    "touch-id": "icon",
    "identity-verify": "icon",
    "finger-print": "icon",
    "fingerprint-pattern": "icon",
    "vpn": "icon",
    "vpn-lock": "icon",
    "secure-web": "icon",
    "private-browsing": "icon",
    "key-round": "icon",
    "access": "icon",
    "vpn-key": "icon",
    "credential": "icon",
    "authentication": "icon",
    "locked": "icon",
    "secure": "icon",
    "private": "icon",
    "lock-closed": "icon",
    "padlock": "icon",
    "unlocked": "icon",
    "unlock": "icon",
    "unsecured": "icon",
    "lock-opened": "icon",
    "padlock-open": "icon",
    "sign-in": "icon",
    "login": "icon",
    "signin": "icon",
    "sign-out": "icon",
    "logout": "icon",
    "signout": "icon",
    "exit": "icon",
    "face-id": "icon",
    "face-recognition": "icon",
    "facial-recognition": "icon",
    "face-scan": "icon",
    "security": "icon",
    "protection": "icon",
    "defend": "icon",
    "guard": "icon",
    "armor": "icon",
    "security-warning": "icon",
    "shield-warning": "icon",
    "shield-exclamation": "icon",
    "vulnerability": "icon",
    "verified-user": "icon",
    "protected": "icon",
    "shield-verified": "icon",
    "unprotected": "icon",
    "insecure": "icon",
    "shield-disabled": "icon",
    "shield-slash": "icon",
    "remove-moderator": "icon",
    "shield-rejected": "icon",
    "blocked": "icon",
    "shield-bad": "icon",
    "security-error": "icon",
    "gpp-bad": "icon",
    "safe": "icon",
    "secure-storage": "icon",
    "strongbox": "icon",
    "encrypted": "icon",
    "venetian-mask": "icon",
    "anonymous": "icon",
    "disguise": "icon",
    "mask": "icon",
    "privacy-mask": "icon",
    "translate": "icon",
    "translation": "icon",
    "language": "icon",
    "i18n": "icon",
    "localization": "icon",
    "l10n": "icon",
    "dark-mode": "icon",
    "night": "icon",
    "dark-theme": "icon",
    "crescent": "icon",
    "preferences": "icon",
    "config": "icon",
    "configuration": "icon",
    "gear": "icon",
    "cog": "icon",
    "sliders-horizontal": "icon",
    "adjustments": "icon",
    "filters-horizontal": "icon",
    "theme-toggle": "icon",
    "dark-mode-toggle": "icon",
    "appearance": "icon",
    "light-dark": "icon",
    "brightness-toggle": "icon",
    "tool": "icon",
    "spanner": "icon",
    "fix": "icon",
    "repair": "icon",
    "build": "icon",
    "configure": "icon",
    "company": "icon",
    "office": "icon",
    "organization": "icon",
    "enterprise": "icon",
    "corporate": "icon",
    "apartment": "icon",
    "board": "icon",
    "task-board": "icon",
    "columns": "icon",
    "view-kanban": "icon",
    "trello": "icon",
    "checkpoint": "icon",
    "flag-pennant": "icon",
    "diamond": "icon",
    "goal": "icon",
    "work": "icon",
    "business": "icon",
    "job": "icon",
    "portfolio": "icon",
    "career": "icon",
    "professional": "icon",
    "money": "icon",
    "cash": "icon",
    "bill": "icon",
    "currency": "icon",
    "payment": "icon",
    "dollar-bill": "icon",
    "price": "icon",
    "cost": "icon",
    "money-circle": "icon",
    "coin": "icon",
    "currency-coins": "icon",
    "change": "icon",
    "tokens": "icon",
    "dollar": "icon",
    "usd": "icon",
    "money-sign": "icon",
    "currency-dollar": "icon",
    "eur": "icon",
    "euro-sign": "icon",
    "currency-euro": "icon",
    "bank": "icon",
    "institution": "icon",
    "finance": "icon",
    "building-bank": "icon",
    "account-balance": "icon",
    "courthouse": "icon",
    "percentage": "icon",
    "discount": "icon",
    "rate": "icon",
    "percent-badge": "icon",
    "balance": "icon",
    "justice": "icon",
    "weigh": "icon",
    "scales": "icon",
    "legal": "icon",
    "purse": "icon",
    "billfold": "icon",
    "account-balance-wallet": "icon",
    "vehicle": "icon",
    "automobile": "icon",
    "driving": "icon",
    "auto": "icon",
    "directions-car": "icon",
    "clinic": "icon",
    "emergency": "icon",
    "local-hospital": "icon",
    "current-location": "icon",
    "near-me": "icon",
    "my-location": "icon",
    "find-location": "icon",
    "gps-fixed": "icon",
    "gps-fix": "icon",
    "my-location-fixed": "icon",
    "location-locked": "icon",
    "atlas": "icon",
    "geography": "icon",
    "map-trifold": "icon",
    "directions": "icon",
    "location": "icon",
    "location-on": "icon",
    "pin-drop": "icon",
    "place": "icon",
    "location-off": "icon",
    "no-location": "icon",
    "remove-location": "icon",
    "unpin-location": "icon",
    "add-location": "icon",
    "new-location": "icon",
    "add-place": "icon",
    "pin-plus": "icon",
    "airplane": "icon",
    "flight": "icon",
    "travel": "icon",
    "aircraft": "icon",
    "path": "icon",
    "navigation": "icon",
    "itinerary": "icon",
    "route-points": "icon",
    "journey": "icon",
    "milestones": "icon",
    "conversion-path": "icon",
    "arrow-path": "icon",
    "window": "icon",
    "desktop-window": "icon",
    "application": "icon",
    "browser-window": "icon",
    "cmd": "icon",
    "meta": "icon",
    "command-key": "icon",
    "keyboard-command": "icon",
    "bottom-panel": "icon",
    "dock-bottom": "icon",
    "layout-bottombar": "icon",
    "bottom-panel-close": "icon",
    "collapse-bottom": "icon",
    "layout-bottombar-collapse": "icon",
    "bottom-panel-open": "icon",
    "expand-bottom": "icon",
    "layout-bottombar-expand": "icon",
    "left-panel": "icon",
    "drawer": "icon",
    "navigation-panel": "icon",
    "sidebar-close": "icon",
    "left-panel-close": "icon",
    "collapse-sidebar": "icon",
    "drawer-close": "icon",
    "sidebar-open": "icon",
    "left-panel-open": "icon",
    "expand-sidebar": "icon",
    "drawer-open": "icon",
    "right-panel": "icon",
    "sidebar-right": "icon",
    "aside": "icon",
    "layout-sidebar-right": "icon",
    "right-panel-close": "icon",
    "sidebar-right-close": "icon",
    "collapse-right": "icon",
    "right-panel-open": "icon",
    "sidebar-right-open": "icon",
    "shutdown": "icon",
    "power-off": "icon",
    "on-off": "icon",
    "switch-off": "icon",
    "power-button": "icon",
    "divider": "icon",
    "horizontal-rule": "icon",
    "hr": "icon",
    "line-separator": "icon",
    "power-cell": "icon",
    "battery-standard": "icon",
    "battery-indicator": "icon",
    "battery-charge": "icon",
    "charging": "icon",
    "power-charging": "icon",
    "battery-100": "icon",
    "battery-complete": "icon",
    "power-full": "icon",
    "battery-empty": "icon",
    "battery-0": "icon",
    "battery-critical": "icon",
    "low-power": "icon",
    "battery-50": "icon",
    "battery-mid": "icon",
    "battery-half": "icon",
    "battery-alert": "icon",
    "battery-error": "icon",
    "battery-critical-alert": "icon",
    "desktop": "icon",
    "pc": "icon",
    "workstation": "icon",
    "desktop-tower": "icon",
    "device-desktop": "icon",
    "processor": "icon",
    "chip": "icon",
    "microchip": "icon",
    "computing": "icon",
    "cpu-chip": "icon",
    "hdd": "icon",
    "disk": "icon",
    "storage": "icon",
    "drive": "icon",
    "audio": "icon",
    "earphones": "icon",
    "headset": "icon",
    "input": "icon",
    "typing": "icon",
    "keys": "icon",
    "notebook-computer": "icon",
    "laptop-mac": "icon",
    "computer-desktop": "icon",
    "device-laptop": "icon",
    "portable": "icon",
    "display": "icon",
    "screen": "icon",
    "responsive": "icon",
    "devices": "icon",
    "device-phone-mobile": "icon",
    "multi-device": "icon",
    "cursor-device": "icon",
    "pointing-device": "icon",
    "print": "icon",
    "printing": "icon",
    "backend": "icon",
    "host": "icon",
    "rack": "icon",
    "hard-drives": "icon",
    "datacenter": "icon",
    "mobile": "icon",
    "phone-mobile": "icon",
    "device-mobile": "icon",
    "cell-phone": "icon",
    "iphone": "icon",
    "ipad": "icon",
    "device-tablet": "icon",
    "tablet-device": "icon",
    "television": "icon",
    "monitor-tv": "icon",
    "device-tv": "icon",
    "usb-port": "icon",
    "usb-drive": "icon",
    "usb-cable": "icon",
    "usb-connection": "icon",
    "smartwatch": "icon",
    "wristwatch": "icon",
    "device-watch": "icon",
    "timepiece": "icon",
    "web-camera": "icon",
    "camera-front": "icon",
    "video-camera-front": "icon",
    "facecam": "icon",
    "bt": "icon",
    "wireless-bluetooth": "icon",
    "bluetooth-disabled": "icon",
    "bt-off": "icon",
    "screencast": "icon",
    "chromecast": "icon",
    "airplay": "icon",
    "screen-mirror": "icon",
    "stream-to": "icon",
    "offline": "icon",
    "no-cloud": "icon",
    "cloud-slash": "icon",
    "disconnected-cloud": "icon",
    "cloud-refresh": "icon",
    "sync-cloud": "icon",
    "cloud-update": "icon",
    "cloud-connection": "icon",
    "world": "icon",
    "earth": "icon",
    "internet": "icon",
    "web": "icon",
    "globe-alt": "icon",
    "nodes": "icon",
    "hub": "icon",
    "connected": "icon",
    "mesh": "icon",
    "plugin": "icon",
    "socket": "icon",
    "outlet": "icon",
    "connector": "icon",
    "power-plug": "icon",
    "broadcast-tower": "icon",
    "cell-tower": "icon",
    "antenna": "icon",
    "transmission-tower": "icon",
    "tower": "icon",
    "wireless": "icon",
    "access-point": "icon",
    "modem": "icon",
    "gateway": "icon",
    "rss-feed": "icon",
    "feed": "icon",
    "syndication": "icon",
    "web-feed": "icon",
    "cell-signal": "icon",
    "signal-strength": "icon",
    "reception": "icon",
    "cellular": "icon",
    "bars": "icon",
    "disconnect": "icon",
    "unplugged": "icon",
    "plug-off": "icon",
    "power-disconnect": "icon",
    "network-wireless": "icon",
    "wi-fi": "icon",
    "wifi-strong": "icon",
    "wifi-full": "icon",
    "network-wifi": "icon",
    "signal-strong": "icon",
    "wifi-weak": "icon",
    "wifi-1-bar": "icon",
    "poor-signal": "icon",
    "weak-connection": "icon",
    "no-wifi": "icon",
    "wireless-off": "icon",
    "wifi-disabled": "icon",
    "no-signal": "icon",
    "wifi-none": "icon",
    "disconnected-wifi": "icon",
    "signal-none": "icon",
    "curly-braces": "icon",
    "brackets-curly": "icon",
    "json": "icon",
    "code-block": "icon",
    "data-object": "icon",
    "code-bracket": "icon",
    "issue": "icon",
    "defect": "icon",
    "bug-report": "icon",
    "debug": "icon",
    "error-bug": "icon",
    "bug-ant": "icon",
    "source-code": "icon",
    "markup": "icon",
    "code-brackets": "icon",
    "dev": "icon",
    "develop": "icon",
    "widget": "icon",
    "module": "icon",
    "extension": "icon",
    "docker": "icon",
    "box-package": "icon",
    "shipping-container": "icon",
    "deployed-code": "icon",
    "db": "icon",
    "datastore": "icon",
    "data-storage": "icon",
    "circle-stack": "icon",
    "sql": "icon",
    "db-backup": "icon",
    "backup-restore": "icon",
    "data-export": "icon",
    "database-restore": "icon",
    "compare": "icon",
    "file-diff": "icon",
    "code-diff": "icon",
    "git-diff": "icon",
    "difference": "icon",
    "branch": "icon",
    "version-branch": "icon",
    "fork-branch": "icon",
    "vcs-branch": "icon",
    "git-commit-horizontal": "icon",
    "commit": "icon",
    "version-commit": "icon",
    "compare-branches": "icon",
    "git-diff-branches": "icon",
    "pull-compare": "icon",
    "compare-arrows": "icon",
    "fork": "icon",
    "branch-fork": "icon",
    "repo-fork": "icon",
    "git-history": "icon",
    "commit-graph": "icon",
    "git-log": "icon",
    "merge-branch": "icon",
    "branch-merge": "icon",
    "pull-request": "icon",
    "pr": "icon",
    "merge-request": "icon",
    "pr-closed": "icon",
    "pull-request-closed": "icon",
    "merge-request-closed": "icon",
    "pr-draft": "icon",
    "pull-request-draft": "icon",
    "merge-request-draft": "icon",
    "log-file": "icon",
    "audit-log": "icon",
    "receipt-long": "icon",
    "event-log": "icon",
    "addon": "icon",
    "puzzle-piece": "icon",
    "integration": "icon",
    "add-on": "icon",
    "regular-expression": "icon",
    "regexp": "icon",
    "pattern-match": "icon",
    "code-search": "icon",
    "find-in-code": "icon",
    "grep": "icon",
    "search-source": "icon",
    "console": "icon",
    "command-line": "icon",
    "cli": "icon",
    "shell": "icon",
    "prompt": "icon",
    "var": "icon",
    "parameter": "icon",
    "code-variable": "icon",
    "callback": "icon",
    "http-hook": "icon",
    "api-hook": "icon",
    "webhooks": "icon",
    "pipeline": "icon",
    "flow": "icon",
    "process": "icon",
    "dag": "icon",
    "github-logo": "icon",
    "brand-github": "icon",
    "medal": "icon",
    "achievement": "icon",
    "ribbon": "icon",
    "badge-award": "icon",
    "prize": "icon",
    "premium": "icon",
    "king": "icon",
    "queen": "icon",
    "vip": "icon",
    "royalty": "icon",
    "pro": "icon",
    "dices": "icon",
    "random": "icon",
    "chance": "icon",
    "gamble": "icon",
    "casino": "icon",
    "roll": "icon",
    "celebrate": "icon",
    "celebration": "icon",
    "confetti": "icon",
    "hooray": "icon",
    "tada": "icon",
    "rating": "icon",
    "bookmark-star": "icon",
    "half-rating": "icon",
    "partial-star": "icon",
    "rating-half": "icon",
    "winner": "icon",
    "champion": "icon",
    "cup": "icon",
    "robot": "icon",
    "ai-bot": "icon",
    "chatbot": "icon",
    "smart-toy": "icon",
    "automation": "icon",
    "ai": "icon",
    "intelligence": "icon",
    "mind": "icon",
    "cognitive": "icon",
    "neural": "icon",
    "smart": "icon",
    "psychology": "icon",
    "magic": "icon",
    "auto-enhance": "icon",
    "stars": "icon",
    "glitter": "icon",
    "sparkle": "icon",
    "wand-sparkles": "icon",
    "auto-fix": "icon",
    "enhance": "icon",
    "wizard": "icon",
    "wand": "icon",
    "documentation": "icon",
    "manual": "icon",
    "reference": "icon",
    "textbook": "icon",
    "guidebook": "icon",
    "read": "icon",
    "reading": "icon",
    "open-book": "icon",
    "story": "icon",
    "novel": "icon",
    "flask-conical": "icon",
    "lab": "icon",
    "experiment": "icon",
    "science": "icon",
    "beaker": "icon",
    "chemistry": "icon",
    "test-tube": "icon",
    "school": "icon",
    "academic-cap": "icon",
    "education": "icon",
    "graduate": "icon",
    "mortarboard": "icon",
    "books": "icon",
    "bookshelf": "icon",
    "collection": "icon",
    "local-library": "icon",
    "cloud-storage": "icon",
    "saas": "icon",
    "hosted": "icon",
    "thunderstorm": "icon",
    "storm": "icon",
    "cloud-storm": "icon",
    "thunder": "icon",
    "rain": "icon",
    "rainy": "icon",
    "precipitation": "icon",
    "weather-rain": "icon",
    "cold": "icon",
    "winter": "icon",
    "freeze": "icon",
    "ac": "icon",
    "air-conditioning": "icon",
    "light-mode": "icon",
    "brightness": "icon",
    "sunny": "icon",
    "day": "icon",
    "temperature": "icon",
    "thermostat": "icon",
    "temp": "icon",
    "air": "icon",
    "breeze": "icon",
    "windy": "icon",
    "gust": "icon",
    "wheelchair": "icon",
    "accessible": "icon",
    "a11y": "icon",
    "disability": "icon",
    "calculate": "icon",
    "math": "icon",
    "computation": "icon",
    "arithmetic": "icon",
    "dot-large": "icon",
    "ring": "icon",
    "radio-button-off": "icon",
    "empty-circle": "icon",
    "cafe": "icon",
    "break": "icon",
    "mug": "icon",
    "espresso": "icon",
    "local-cafe": "icon",
    "ip": "icon",
    "rights": "icon",
    "legal-copyright": "icon",
    "medical": "icon",
    "first-aid": "icon",
    "hospital-cross": "icon",
    "health": "icon",
    "red-cross": "icon",
    "medical-cross": "icon",
    "unlimited": "icon",
    "infinite": "icon",
    "all-inclusive": "icon",
    "forever": "icon",
    "eco": "icon",
    "nature": "icon",
    "plant": "icon",
    "organic": "icon",
    "environment": "icon",
    "idea": "icon",
    "tip": "icon",
    "bulb": "icon",
    "light-bulb": "icon",
    "hint": "icon",
    "suggestion": "icon",
    "recycling": "icon",
    "sustainable": "icon",
    "rectangle": "icon",
    "box-empty": "icon",
    "shape-square": "icon",
    "crosshair-circle": "icon",
    "focal-point": "icon",
    "shape-triangle": "icon",
    "delta": "icon",
    "change-history": "icon"
  },
  "propertyTypes": {
    "icon": "string",
    "disabled": "string",
    "loading": "boolean",
    "link": "boolean",
    "fitted": "boolean",
    "color": "string",
    "size": "string",
    "spin": "boolean",
    "set": "string",
    "href": "string",
    "target": "string"
  },
  "allowedValues": {
    "icon": [
      "arrow-down",
      "arrow-left",
      "arrow-left-right",
      "arrow-right",
      "arrow-up",
      "arrow-up-down",
      "chevron-down",
      "chevron-first",
      "chevron-last",
      "chevron-left",
      "chevron-right",
      "chevron-up",
      "chevrons-down-up",
      "chevrons-left-right",
      "chevrons-up-down",
      "compass",
      "corner-down-left",
      "corner-down-right",
      "crosshair",
      "external-link",
      "home",
      "layout-panel-left",
      "layout-panel-top",
      "menu",
      "mouse-pointer",
      "archive",
      "archive-restore",
      "archive-x",
      "arrow-down-a-z",
      "arrow-up-a-z",
      "bookmark",
      "bookmark-check",
      "bookmark-plus",
      "circle-ellipsis",
      "circle-minus",
      "circle-plus",
      "circle-x",
      "clipboard",
      "clipboard-paste",
      "cloud-download",
      "cloud-upload",
      "copy",
      "copy-check",
      "backspace",
      "download",
      "ellipsis",
      "ellipsis-vertical",
      "expand",
      "eye",
      "eye-off",
      "grip-horizontal",
      "grip-vertical",
      "hand",
      "heart",
      "heart-off",
      "link",
      "list-checks",
      "maximize",
      "merge",
      "minimize",
      "minus",
      "mouse-pointer-click",
      "move",
      "paperclip",
      "pencil",
      "pin",
      "pin-off",
      "plus",
      "redo",
      "refresh",
      "replace",
      "rocket",
      "rotate-ccw",
      "rotate-cw",
      "save",
      "scan",
      "scissors",
      "search",
      "share",
      "split",
      "thumbs-down",
      "thumbs-up",
      "trash",
      "undo",
      "unlink",
      "upload",
      "vote",
      "x",
      "zoom-in",
      "zoom-out",
      "badge-alert",
      "badge-check",
      "badge-info",
      "ban",
      "check",
      "check-check",
      "error",
      "circle-check",
      "circle-dashed",
      "help",
      "construction",
      "flag",
      "flame",
      "frown",
      "info",
      "life-buoy",
      "loader",
      "loader-circle",
      "meh",
      "server-crash",
      "warning",
      "bolt",
      "avatar",
      "contact",
      "id-card",
      "user",
      "user-check",
      "user-cog",
      "user-minus",
      "user-plus",
      "user-search",
      "user-x",
      "users",
      "circle-dot",
      "password",
      "square-check",
      "text-cursor-input",
      "toggle-left",
      "toggle-right",
      "activity",
      "chart-area",
      "chart-bar",
      "chart-bar-stacked",
      "chart-candlestick",
      "chart-gantt",
      "chart-line",
      "chart-network",
      "chart-pie",
      "chart-scatter",
      "clipboard-list",
      "funnel",
      "gauge",
      "grid-2x2",
      "grid-3x3",
      "layout-dashboard",
      "layout-grid",
      "layout-list",
      "list-filter",
      "list-tree",
      "qr-code",
      "radar",
      "sigma",
      "table",
      "table-cells-merge",
      "table-cells-split",
      "trending-down",
      "trending-up",
      "file",
      "file-archive",
      "file-check",
      "file-code",
      "file-image",
      "file-lock",
      "file-plus",
      "file-search",
      "file-spreadsheet",
      "file-text",
      "file-x",
      "files",
      "folder",
      "folder-open",
      "folder-plus",
      "folder-tree",
      "newspaper",
      "notebook",
      "presentation",
      "scroll-text",
      "sticky-note",
      "audio-lines",
      "camera",
      "camera-off",
      "captions",
      "film",
      "gallery-horizontal",
      "image",
      "image-off",
      "image-plus",
      "images",
      "mic",
      "mic-off",
      "music",
      "podcast",
      "video",
      "video-off",
      "circle-pause",
      "circle-play",
      "circle-stop",
      "fast-forward",
      "pause",
      "picture-in-picture",
      "play",
      "repeat",
      "rewind",
      "shuffle",
      "skip-back",
      "skip-forward",
      "volume-high",
      "volume-low",
      "volume-x",
      "a-arrow-down",
      "a-arrow-up",
      "a-large-small",
      "asterisk",
      "bold",
      "hash",
      "heading",
      "heading-1",
      "heading-2",
      "heading-3",
      "italic",
      "list",
      "list-indent-decrease",
      "list-indent-increase",
      "list-ordered",
      "quote",
      "remove-formatting",
      "spell-check",
      "strikethrough",
      "subscript",
      "superscript",
      "table-of-contents",
      "text-align-center",
      "text-align-end",
      "text-align-justify",
      "text-align-start",
      "text-quote",
      "text-select",
      "type",
      "underline",
      "align-center-horizontal",
      "align-center-vertical",
      "align-end-horizontal",
      "align-end-vertical",
      "align-start-horizontal",
      "align-start-vertical",
      "bring-to-front",
      "columns-2",
      "columns-3",
      "crop",
      "droplet",
      "eraser",
      "flip-horizontal",
      "flip-vertical",
      "highlighter",
      "layers",
      "paint-bucket",
      "brush",
      "palette",
      "eyedropper",
      "ruler",
      "send-to-back",
      "shapes",
      "signature",
      "at-sign",
      "bell",
      "bell-dot",
      "bell-off",
      "bell-ring",
      "forward",
      "inbox",
      "mail",
      "mail-open",
      "mail-plus",
      "megaphone",
      "chat",
      "chat-more",
      "chat-plus",
      "message-square",
      "message-square-dot",
      "message-square-reply",
      "messages-square",
      "phone",
      "phone-call",
      "phone-missed",
      "phone-off",
      "reply",
      "reply-all",
      "screen-share",
      "screen-share-off",
      "send",
      "smile",
      "voicemail",
      "barcode",
      "box",
      "credit-card",
      "gift",
      "package",
      "package-open",
      "receipt",
      "shopping-bag",
      "shopping-cart",
      "store",
      "tag",
      "tags",
      "ticket",
      "truck",
      "alarm-clock",
      "calendar",
      "calendar-check",
      "calendar-clock",
      "calendar-days",
      "calendar-plus",
      "calendar-range",
      "calendar-x",
      "clock",
      "history",
      "hourglass",
      "timer",
      "cookie",
      "fingerprint",
      "globe-lock",
      "key",
      "lock",
      "lock-open",
      "log-in",
      "log-out",
      "scan-face",
      "shield",
      "shield-alert",
      "shield-check",
      "shield-off",
      "shield-x",
      "vault",
      "incognito",
      "languages",
      "moon",
      "settings",
      "sliders",
      "sun-moon",
      "wrench",
      "building",
      "kanban",
      "milestone",
      "briefcase",
      "banknote",
      "circle-dollar-sign",
      "coins",
      "dollar-sign",
      "euro",
      "landmark",
      "percent",
      "scale",
      "wallet",
      "car",
      "hospital",
      "locate",
      "locate-fixed",
      "map",
      "map-pin",
      "map-pin-off",
      "map-pin-plus",
      "plane",
      "route",
      "waypoints",
      "app-window",
      "command",
      "panel-bottom",
      "panel-bottom-close",
      "panel-bottom-open",
      "sidebar",
      "panel-left-close",
      "panel-left-open",
      "panel-right",
      "panel-right-close",
      "panel-right-open",
      "power",
      "separator-horizontal",
      "battery",
      "battery-charging",
      "battery-full",
      "battery-low",
      "battery-medium",
      "battery-warning",
      "computer",
      "cpu",
      "hard-drive",
      "headphones",
      "keyboard",
      "laptop",
      "monitor",
      "monitor-smartphone",
      "mouse",
      "printer",
      "server",
      "smartphone",
      "tablet",
      "tv",
      "usb",
      "watch",
      "webcam",
      "bluetooth",
      "bluetooth-off",
      "cast",
      "cloud-off",
      "cloud-sync",
      "globe",
      "network",
      "plug",
      "radio-tower",
      "router",
      "rss",
      "signal",
      "unplug",
      "wifi",
      "wifi-high",
      "wifi-low",
      "wifi-off",
      "wifi-zero",
      "braces",
      "bug",
      "code",
      "component",
      "container",
      "database",
      "database-backup",
      "diff",
      "git-branch",
      "git-commit",
      "git-compare",
      "git-fork",
      "git-graph",
      "git-merge",
      "git-pull-request",
      "git-pull-request-closed",
      "git-pull-request-draft",
      "logs",
      "puzzle",
      "regex",
      "search-code",
      "terminal",
      "variable",
      "webhook",
      "workflow",
      "github",
      "award",
      "crown",
      "dice",
      "party-popper",
      "star",
      "star-half",
      "trophy",
      "bot",
      "brain",
      "sparkles",
      "magic-wand",
      "book",
      "book-open",
      "flask",
      "graduation-cap",
      "library",
      "cloud",
      "cloud-lightning",
      "cloud-rain",
      "snowflake",
      "sun",
      "thermometer",
      "wind",
      "accessibility",
      "calculator",
      "circle",
      "coffee",
      "copyright",
      "cross",
      "hexagon",
      "infinity",
      "leaf",
      "lightbulb",
      "recycle",
      "square",
      "target",
      "triangle",
      "down",
      "arrow-downward",
      "move-down",
      "left",
      "back",
      "arrow-back",
      "previous",
      "horizontal",
      "resize-horizontal",
      "swap-horizontal",
      "swap-horiz",
      "arrows-horizontal",
      "bidirectional",
      "right",
      "arrow-forward",
      "next",
      "go-right",
      "up",
      "arrow-upward",
      "move-up",
      "vertical",
      "resize-vertical",
      "swap-vertical",
      "swap-vert",
      "arrows-vertical",
      "caret-down",
      "dropdown",
      "arrow-drop-down",
      "select-arrow",
      "collapse-down",
      "angle-down",
      "skip-to-start",
      "first-page",
      "page-first",
      "go-to-first",
      "chevron-double-left",
      "step-first",
      "skip-to-end",
      "last-page",
      "page-last",
      "go-to-last",
      "chevron-double-right",
      "step-last",
      "caret-left",
      "collapse-left",
      "nav-left",
      "angle-left",
      "caret-right",
      "expand-right",
      "nav-right",
      "angle-right",
      "caret-up",
      "collapse",
      "collapse-up",
      "angle-up",
      "collapse-vertical",
      "unfold-less",
      "collapse-all",
      "fold",
      "expand-horizontal",
      "unfold-horizontal",
      "expand-width",
      "expand-vertical",
      "unfold-more",
      "sort-indicator",
      "selector",
      "select",
      "caret-up-down",
      "unfold",
      "explore",
      "direction",
      "navigate",
      "discover",
      "safari",
      "return-key",
      "enter",
      "subdirectory-left",
      "arrow-bend-down-left",
      "carriage-return",
      "subdirectory-right",
      "arrow-bend-down-right",
      "forward-down",
      "target-location",
      "aim",
      "gps",
      "location-searching",
      "viewfinder",
      "scope",
      "square-arrow-out-up-right",
      "open-in-new",
      "new-window",
      "new-tab",
      "launch",
      "arrow-square-out",
      "outbound",
      "open-external",
      "house",
      "homepage",
      "main",
      "sidebar-left",
      "layout-sidebar",
      "view-sidebar",
      "side-panel",
      "navbar",
      "layout-navbar",
      "header-panel",
      "top-bar",
      "web-asset",
      "hamburger",
      "hamburger-menu",
      "bars-3",
      "navigation-menu",
      "nav-menu",
      "cursor",
      "pointer",
      "arrow-cursor",
      "cursor-arrow",
      "arrow-selector",
      "archive-box",
      "file-away",
      "put-away",
      "unarchive",
      "restore",
      "archive-undo",
      "archive-remove",
      "archive-delete",
      "archive-off",
      "sort-alpha-asc",
      "sort-ascending",
      "sort-alpha-down",
      "sort-az",
      "sort-alphabetical",
      "sort-alpha-desc",
      "sort-descending",
      "sort-alpha-up",
      "sort-za",
      "sort-alphabetical-reverse",
      "save-for-later",
      "saved",
      "flag-bookmark",
      "reading-list",
      "bookmark-saved",
      "bookmark-done",
      "bookmark-confirmed",
      "bookmark-add",
      "add-bookmark",
      "bookmark-new",
      "more-circle",
      "dots-circle",
      "pending-actions",
      "options-circle",
      "remove-circle",
      "subtract-circle",
      "minus-circle",
      "add-circle",
      "create-circle",
      "plus-circle",
      "new-circle",
      "cancel",
      "close-circle",
      "dismiss",
      "x-circle",
      "paste-board",
      "assignment",
      "copy-board",
      "paste",
      "content-paste",
      "paste-from-clipboard",
      "download-cloud",
      "cloud-save",
      "cloud-arrow-down",
      "upload-cloud",
      "cloud-push",
      "cloud-arrow-up",
      "duplicate",
      "clone",
      "content-copy",
      "copy-to-clipboard",
      "copied",
      "copy-success",
      "clipboard-check",
      "copy-confirmed",
      "back-delete",
      "erase-back",
      "remove-character",
      "download-file",
      "export",
      "arrow-down-tray",
      "more",
      "dots",
      "three-dots",
      "more-horizontal",
      "kebab-horizontal",
      "options",
      "more-vertical",
      "dots-vertical",
      "three-dots-vertical",
      "kebab-menu",
      "kebab",
      "options-vertical",
      "fullscreen",
      "enlarge",
      "arrows-out",
      "open-in-full",
      "grow",
      "view",
      "visible",
      "show",
      "visibility",
      "preview",
      "hidden",
      "hide",
      "invisible",
      "visibility-off",
      "eye-slash",
      "conceal",
      "drag-handle",
      "drag-horizontal",
      "dots-six",
      "handle-horizontal",
      "reorder",
      "drag-indicator",
      "drag-vertical",
      "dots-six-vertical",
      "handle-vertical",
      "stop",
      "hand-stop",
      "hand-raised",
      "raise-hand",
      "pan-tool",
      "halt",
      "like",
      "love",
      "favorite",
      "favourite",
      "unlike",
      "heart-broken",
      "unfavorite",
      "dislike",
      "heart-break",
      "hyperlink",
      "url",
      "chain",
      "anchor",
      "list-check",
      "completed-tasks",
      "expand-full",
      "arrows-maximize",
      "combine",
      "join",
      "arrows-merge",
      "converge",
      "exit-fullscreen",
      "shrink",
      "collapse-full",
      "arrows-minimize",
      "arrows-in",
      "reduce",
      "subtract",
      "dash",
      "cursor-click",
      "click",
      "tap",
      "pointer-click",
      "ads-click",
      "drag",
      "reposition",
      "arrows-move",
      "open-with",
      "arrows-out-cardinal",
      "rearrange",
      "attach",
      "attachment",
      "attach-file",
      "paper-clip",
      "clip",
      "edit",
      "modify",
      "write",
      "pen",
      "push-pin",
      "pinned",
      "thumbtack",
      "keep",
      "tack",
      "unpin",
      "pinned-off",
      "remove-pin",
      "keep-off",
      "add",
      "create",
      "new",
      "insert",
      "redo-action",
      "arrow-clockwise",
      "step-forward",
      "refresh-ccw",
      "reload",
      "sync",
      "update",
      "retry",
      "find-replace",
      "swap",
      "substitute",
      "search-replace",
      "find-and-replace",
      "deploy",
      "liftoff",
      "rocket-launch",
      "blast-off",
      "ship-it",
      "rotate-left",
      "rotate-counter-clockwise",
      "turn-left",
      "rotate-right",
      "rotate-clockwise",
      "turn-right",
      "floppy-disk",
      "floppy",
      "persist",
      "save-file",
      "device-floppy",
      "crop-free",
      "camera-scan",
      "viewfinder-circle",
      "cut",
      "content-cut",
      "snip",
      "clip-content",
      "find",
      "magnifying-glass",
      "lookup",
      "look-up",
      "share-link",
      "distribute",
      "spread",
      "share-network",
      "divide",
      "fork-vertical",
      "call-split",
      "downvote",
      "thumb-down",
      "reject",
      "disapprove",
      "upvote",
      "thumb-up",
      "approve",
      "recommend",
      "delete",
      "bin",
      "garbage",
      "discard",
      "revert",
      "undo-action",
      "arrow-counter-clockwise",
      "go-back",
      "step-back",
      "link-break",
      "remove-link",
      "disconnect-link",
      "link-off",
      "chain-break",
      "publish",
      "export-file",
      "arrow-up-tray",
      "upload-file",
      "ballot",
      "poll",
      "election",
      "how-to-vote",
      "cast-vote",
      "close",
      "remove",
      "magnify",
      "zoom-plus",
      "magnifying-glass-plus",
      "scale-up",
      "badge-warning",
      "seal-warning",
      "badge-exclamation",
      "verified-warning",
      "verified",
      "certified",
      "seal-check",
      "badge-verified",
      "rosette",
      "badge-question",
      "seal-info",
      "badge-information",
      "block",
      "prohibit",
      "forbidden",
      "no-entry",
      "restricted",
      "no-symbol",
      "done",
      "confirm",
      "checkmark",
      "tick",
      "complete",
      "yes",
      "ok",
      "double-check",
      "read-receipt",
      "done-all",
      "all-done",
      "verified-check",
      "circle-alert",
      "error-circle",
      "warning-circle",
      "alert-circle",
      "exclamation-circle",
      "circle-exclamation",
      "circle-warning",
      "success",
      "check-circle",
      "complete-circle",
      "done-circle",
      "approved",
      "circle-success",
      "pending",
      "in-progress",
      "loading-circle",
      "incomplete",
      "circle-question-mark",
      "help-circle",
      "faq",
      "question",
      "question-circle",
      "support",
      "under-construction",
      "maintenance",
      "roadblock",
      "barricade",
      "wip",
      "report",
      "flag-report",
      "flagged",
      "mark",
      "banner",
      "fire",
      "hot",
      "popular",
      "burn",
      "lit",
      "sad",
      "unhappy",
      "dissatisfied",
      "negative",
      "sad-face",
      "emoji-sad",
      "information",
      "info-circle",
      "information-circle",
      "about",
      "details",
      "lifebuoy",
      "rescue",
      "life-ring",
      "spinner",
      "spinner-gap",
      "autorenew",
      "busy",
      "spinner-circle",
      "progress-activity",
      "buffering",
      "neutral",
      "indifferent",
      "smiley-meh",
      "sentiment-neutral",
      "expressionless",
      "server-error",
      "server-down",
      "server-off",
      "server-failure",
      "outage",
      "triangle-alert",
      "caution",
      "alert-triangle",
      "danger",
      "exclamation-triangle",
      "zap",
      "lightning",
      "flash",
      "electric",
      "instant",
      "circle-user",
      "user-circle",
      "account-circle",
      "profile",
      "user-avatar",
      "address-book",
      "contact-card",
      "vcard",
      "person-details",
      "identification",
      "badge",
      "identity-card",
      "id",
      "name-badge",
      "credentials",
      "person",
      "account",
      "member",
      "user-verified",
      "user-approved",
      "person-check",
      "how-to-reg",
      "user-confirm",
      "user-settings",
      "user-preferences",
      "manage-accounts",
      "user-gear",
      "user-config",
      "remove-user",
      "unfriend",
      "person-remove",
      "user-remove",
      "add-user",
      "new-user",
      "person-add",
      "user-add",
      "invite-user",
      "find-user",
      "person-search",
      "lookup-user",
      "user-find",
      "block-user",
      "ban-user",
      "person-off",
      "user-block",
      "user-reject",
      "group",
      "team",
      "people",
      "members",
      "community",
      "radio-button",
      "radio",
      "record",
      "bullseye",
      "selected",
      "rectangle-ellipsis",
      "password-field",
      "hidden-input",
      "password-input",
      "dots-input",
      "checkbox",
      "checkbox-checked",
      "check-box",
      "check-square",
      "task-done",
      "text-input",
      "cursor-text",
      "input-cursor",
      "text-field",
      "toggle-off",
      "toggle-inactive",
      "toggle-on",
      "switch-on",
      "toggle-active",
      "pulse",
      "heartbeat",
      "heart-rate",
      "vital-signs",
      "monitoring",
      "area-chart",
      "graph-area",
      "chart-area-line",
      "bar-chart",
      "graph-bar",
      "bar-graph",
      "histogram",
      "analytics",
      "stacked-bar",
      "stacked-chart",
      "stacked-bar-chart",
      "candlestick",
      "stock-chart",
      "financial-chart",
      "ohlc",
      "gantt",
      "timeline-chart",
      "project-timeline",
      "project-chart",
      "line-chart",
      "graph-line",
      "line-graph",
      "trend",
      "show-chart",
      "graph",
      "network-graph",
      "graph-network",
      "topology",
      "node-graph",
      "relationship-graph",
      "mind-map",
      "pie-chart",
      "donut-chart",
      "graph-pie",
      "pie-graph",
      "scatter-plot",
      "dot-plot",
      "scatter-chart",
      "data-points",
      "task-list",
      "checklist",
      "todo-list",
      "assignment-list",
      "filter",
      "filter-list",
      "sort-funnel",
      "filter-alt",
      "sieve",
      "speedometer",
      "performance",
      "speed",
      "meter",
      "dashboard-gauge",
      "tachometer",
      "grid-four",
      "grid-view",
      "squares-2x2",
      "grid-small",
      "grid-nine",
      "grid-large",
      "dashboard",
      "widgets",
      "dashboard-layout",
      "rectangle-group",
      "apps",
      "grid-layout",
      "app-grid",
      "list-view",
      "view-list",
      "queue-list",
      "sort-filter",
      "tree-view",
      "nested-list",
      "qrcode",
      "barcode-2d",
      "chart-polar",
      "sonar",
      "detection",
      "sweep",
      "sum",
      "summation",
      "aggregate",
      "total",
      "math-sigma",
      "data-table",
      "grid",
      "data-grid",
      "merge-cells",
      "cell-merge",
      "combine-cells",
      "split-cells",
      "cell-split",
      "unmerge-cells",
      "trend-down",
      "decrease",
      "decline",
      "arrow-trending-down",
      "downtrend",
      "trend-up",
      "increase",
      "growth",
      "arrow-trending-up",
      "uptrend",
      "document",
      "page",
      "doc",
      "draft",
      "zip",
      "compressed",
      "archive-file",
      "file-zip",
      "rar",
      "file-verified",
      "file-approved",
      "file-done",
      "document-check",
      "source-file",
      "code-file",
      "script",
      "integration-instructions",
      "image-file",
      "photo-file",
      "picture-file",
      "media-file",
      "file-protected",
      "file-encrypted",
      "secure-file",
      "file-shield",
      "new-file",
      "create-file",
      "add-file",
      "file-add",
      "note-add",
      "find-in-file",
      "search-file",
      "file-find",
      "find-in-page",
      "excel",
      "csv",
      "file-xls",
      "spreadsheet",
      "file-table",
      "text-file",
      "document-text",
      "readme",
      "description",
      "file-document",
      "file-remove",
      "file-delete",
      "file-reject",
      "remove-file",
      "documents",
      "multiple-files",
      "file-copy",
      "file-stack",
      "directory",
      "dir",
      "open-folder",
      "folder-opened",
      "directory-open",
      "new-folder",
      "create-folder",
      "add-folder",
      "folder-add",
      "directory-tree",
      "file-tree",
      "folder-structure",
      "sitemap",
      "hierarchy",
      "account-tree",
      "news",
      "article",
      "press",
      "publication",
      "headline",
      "journal",
      "diary",
      "notepad",
      "menu-book",
      "slides",
      "keynote",
      "pitch-deck",
      "terms",
      "legal-document",
      "terms-of-service",
      "scroll",
      "manuscript",
      "note",
      "memo",
      "post-it",
      "reminder-note",
      "waveform",
      "sound-wave",
      "equalizer",
      "audio-wave",
      "graphic-eq",
      "spectrum",
      "photo",
      "take-photo",
      "snapshot",
      "capture",
      "photography",
      "photo-camera",
      "no-camera",
      "camera-disabled",
      "camera-slash",
      "no-photography",
      "subtitles",
      "closed-captions",
      "cc",
      "closed-captioning",
      "subtitle",
      "movie",
      "video-film",
      "cinema",
      "reel",
      "film-strip",
      "carousel",
      "image-gallery",
      "slideshow",
      "photo-gallery",
      "view-carousel",
      "picture",
      "img",
      "photograph",
      "image-broken",
      "photo-off",
      "broken-image",
      "hide-image",
      "no-image",
      "add-photo",
      "photo-plus",
      "add-image",
      "camera-plus",
      "upload-image",
      "gallery",
      "photo-library",
      "photo-album",
      "photos",
      "library-photo",
      "microphone",
      "record-audio",
      "voice",
      "mute",
      "microphone-off",
      "muted",
      "mic-mute",
      "microphone-slash",
      "song",
      "music-note",
      "musical-note",
      "tune",
      "audio-show",
      "podcasts",
      "radio-show",
      "camera-video",
      "videocam",
      "video-camera",
      "record-video",
      "cam",
      "camera-off-video",
      "videocam-off",
      "video-disabled",
      "video-camera-slash",
      "no-video",
      "pause-circle",
      "pause-button",
      "play-circle",
      "play-button",
      "stop-circle",
      "stop-button",
      "skip-ahead",
      "speed-up",
      "ff",
      "next-track",
      "hold",
      "player-pause",
      "pause-playback",
      "pip",
      "floating-video",
      "mini-player",
      "start",
      "resume",
      "play-arrow",
      "player-play",
      "loop",
      "repeat-playback",
      "cycle",
      "fast-rewind",
      "skip-backward",
      "backward",
      "player-track-prev",
      "randomize",
      "mix",
      "arrows-shuffle",
      "previous-track",
      "skip-previous",
      "step-backward",
      "player-skip-back",
      "skip-next",
      "player-skip-forward",
      "volume-2",
      "volume-up",
      "speaker",
      "speaker-high",
      "sound",
      "volume-down",
      "volume-1",
      "speaker-low",
      "quiet",
      "low-volume",
      "volume-mute",
      "volume-off",
      "speaker-mute",
      "sound-off",
      "speaker-x-mark",
      "no-sound",
      "font-size-decrease",
      "text-decrease",
      "font-decrease",
      "text-smaller",
      "font-size-increase",
      "text-increase",
      "font-increase",
      "text-larger",
      "font-size",
      "text-resize",
      "format-size",
      "text-size",
      "required",
      "star-small",
      "wildcard",
      "footnote",
      "text-bold",
      "format-bold",
      "strong",
      "hashtag",
      "number-sign",
      "pound",
      "title",
      "text-h",
      "h1",
      "h2",
      "h3",
      "format-italic",
      "text-italic",
      "emphasis",
      "unordered-list",
      "bullet-list",
      "list-bullet",
      "list-ul",
      "format-list-bulleted",
      "outdent",
      "indent-decrease",
      "text-outdent",
      "dedent",
      "indent",
      "indent-increase",
      "text-indent",
      "tab",
      "numbered-list",
      "list-numbers",
      "list-ol",
      "format-list-numbered",
      "ordered-list",
      "blockquote",
      "citation",
      "quotes",
      "format-quote",
      "quotation",
      "clear-formatting",
      "format-clear",
      "strip-formatting",
      "plain-text",
      "spellcheck",
      "grammar",
      "proofread",
      "abc-check",
      "line-through",
      "text-strikethrough",
      "format-strikethrough",
      "crossed-out",
      "text-subscript",
      "format-subscript",
      "sub",
      "text-superscript",
      "format-superscript",
      "sup",
      "toc",
      "index",
      "outline",
      "page-index",
      "align-center",
      "center-align",
      "format-align-center",
      "align-right",
      "right-align",
      "text-align-right",
      "format-align-right",
      "justify",
      "align-justify",
      "format-align-justify",
      "align-left",
      "left-align",
      "text-align-left",
      "format-align-left",
      "quote-block",
      "pull-quote",
      "select-text",
      "text-selection",
      "highlight-text",
      "selection",
      "select-all",
      "typography",
      "font",
      "text-format",
      "text-fields",
      "typeface",
      "text-underline",
      "format-underline",
      "format-underlined",
      "align-horizontal-center",
      "center-horizontal",
      "align-vertical-center",
      "center-vertical",
      "align-horizontal-right",
      "align-right-horizontal",
      "align-bottom-horizontal",
      "align-vertical-bottom",
      "align-bottom-vertical",
      "align-right-vertical",
      "align-horizontal-left",
      "align-left-horizontal",
      "align-top-horizontal",
      "align-vertical-top",
      "align-top-vertical",
      "align-left-vertical",
      "layer-front",
      "move-front",
      "foreground",
      "stack-front",
      "flip-to-front",
      "two-columns",
      "split-view",
      "dual-pane",
      "view-column",
      "three-columns",
      "triple-pane",
      "multi-column",
      "trim",
      "crop-image",
      "resize-crop",
      "water",
      "drop",
      "color-drop",
      "water-drop",
      "liquid",
      "ink",
      "clear",
      "erase",
      "rubber",
      "wipe",
      "mirror-horizontal",
      "reflect-horizontal",
      "mirror-vertical",
      "reflect-vertical",
      "highlight",
      "marker",
      "ink-highlighter",
      "text-highlight",
      "stack",
      "stacked",
      "depth",
      "rectangle-stack",
      "overlay",
      "fill",
      "color-fill",
      "flood-fill",
      "format-color-fill",
      "paintbrush",
      "paint",
      "draw",
      "color-palette",
      "swatch",
      "theme",
      "colors",
      "pipette",
      "color-picker",
      "colorize",
      "eye-dropper",
      "color-sample",
      "measure",
      "dimensions",
      "straighten",
      "measurement",
      "move-back",
      "layer-back",
      "stack-back",
      "flip-to-back",
      "behind",
      "geometry",
      "design-elements",
      "primitives",
      "autograph",
      "sign",
      "handwriting",
      "at",
      "mention",
      "email-at",
      "at-symbol",
      "notification",
      "alert",
      "notifications",
      "reminder-bell",
      "notification-badge",
      "notification-unread",
      "bell-badge",
      "bell-alert",
      "notification-new",
      "bell-important",
      "notification-off",
      "mute-notification",
      "bell-mute",
      "bell-slash",
      "notifications-off",
      "do-not-disturb",
      "notification-active",
      "bell-ringing",
      "bell-active",
      "notifications-active",
      "ringing",
      "forward-message",
      "send-forward",
      "share-forward",
      "tray",
      "mailbox",
      "email",
      "envelope",
      "letter",
      "e-mail",
      "email-open",
      "envelope-open",
      "read-mail",
      "mail-opened",
      "drafts",
      "compose",
      "new-email",
      "new-mail",
      "write-email",
      "outgoing-mail",
      "announcement",
      "broadcast",
      "campaign",
      "speakerphone",
      "bullhorn",
      "promote",
      "message-circle",
      "chat-bubble",
      "conversation",
      "chat-circle",
      "comment-circle",
      "bubble",
      "message-circle-more",
      "chat-dots",
      "chat-typing",
      "message-dots",
      "chat-loading",
      "message-circle-plus",
      "new-chat",
      "add-comment",
      "new-conversation",
      "start-chat",
      "comment",
      "chat-square",
      "message",
      "speech-bubble",
      "chat-bubble-left",
      "unread-message",
      "new-message",
      "chat-notification",
      "mark-chat-unread",
      "reply-message",
      "message-reply",
      "quick-reply",
      "respond",
      "forum",
      "conversation-thread",
      "chats",
      "discussion",
      "chat-thread",
      "call",
      "telephone",
      "dial",
      "handset",
      "incoming-call",
      "phone-ringing",
      "active-call",
      "phone-in-talk",
      "missed-call",
      "phone-x",
      "phone-disabled",
      "end-call",
      "hangup",
      "phone-slash",
      "no-phone",
      "write-back",
      "arrow-reply",
      "respond-all",
      "reply-to-all",
      "present-screen",
      "share-display",
      "cast-screen",
      "stop-screenshare",
      "stop-screen-share",
      "end-presentation",
      "screencast-off",
      "submit",
      "paper-plane",
      "dispatch",
      "paper-airplane",
      "smiley",
      "happy",
      "emoji",
      "face-smile",
      "mood-happy",
      "sentiment-satisfied",
      "voice-message",
      "answering-machine",
      "phone-voicemail",
      "upc",
      "product-code",
      "scan-code",
      "cube",
      "crate",
      "parcel",
      "carton",
      "inventory",
      "card",
      "debit-card",
      "pay",
      "billing",
      "present",
      "reward",
      "redeem",
      "giveaway",
      "shipment",
      "box-sealed",
      "delivery",
      "bundle",
      "unbox",
      "unboxing",
      "package-unpack",
      "cube-transparent",
      "invoice",
      "receipt-text",
      "transaction",
      "receipt-percent",
      "bag",
      "purchase-bag",
      "store-bag",
      "retail-bag",
      "cart",
      "basket",
      "checkout",
      "trolley",
      "add-to-cart",
      "shop",
      "storefront",
      "retail",
      "marketplace",
      "building-store",
      "label",
      "price-tag",
      "sell",
      "badge-tag",
      "labels",
      "multi-tag",
      "price-tags",
      "coupon",
      "admission",
      "pass",
      "confirmation-number",
      "voucher",
      "shipping",
      "freight",
      "local-shipping",
      "transport",
      "alarm",
      "reminder",
      "wake-up",
      "timer-alert",
      "date",
      "schedule",
      "datepicker",
      "date-picker",
      "calendar-today",
      "event-confirmed",
      "date-confirmed",
      "calendar-done",
      "event-available",
      "calendar-confirmed",
      "schedule-time",
      "event-time",
      "calendar-time",
      "date-time",
      "appointment",
      "calendar-month",
      "calendar-event",
      "date-range-view",
      "monthly-view",
      "add-event",
      "new-event",
      "calendar-add",
      "schedule-new",
      "create-event",
      "date-range",
      "date-span",
      "calendar-period",
      "date-picker-range",
      "cancel-event",
      "remove-event",
      "calendar-cancel",
      "event-busy",
      "calendar-delete",
      "time",
      "hour",
      "oclock",
      "recent",
      "clock-history",
      "time-past",
      "activity-log",
      "timer-sand",
      "waiting",
      "sandglass",
      "hourglass-empty",
      "stopwatch",
      "countdown",
      "elapsed",
      "time-elapsed",
      "consent",
      "browser-cookie",
      "biscuit",
      "gdpr",
      "biometric",
      "touch-id",
      "identity-verify",
      "finger-print",
      "fingerprint-pattern",
      "vpn",
      "vpn-lock",
      "secure-web",
      "private-browsing",
      "key-round",
      "access",
      "vpn-key",
      "credential",
      "authentication",
      "locked",
      "secure",
      "private",
      "lock-closed",
      "padlock",
      "unlocked",
      "unlock",
      "unsecured",
      "lock-opened",
      "padlock-open",
      "sign-in",
      "login",
      "signin",
      "sign-out",
      "logout",
      "signout",
      "exit",
      "face-id",
      "face-recognition",
      "facial-recognition",
      "face-scan",
      "security",
      "protection",
      "defend",
      "guard",
      "armor",
      "security-warning",
      "shield-warning",
      "shield-exclamation",
      "vulnerability",
      "verified-user",
      "protected",
      "shield-verified",
      "unprotected",
      "insecure",
      "shield-disabled",
      "shield-slash",
      "remove-moderator",
      "shield-rejected",
      "blocked",
      "shield-bad",
      "security-error",
      "gpp-bad",
      "safe",
      "secure-storage",
      "strongbox",
      "encrypted",
      "venetian-mask",
      "anonymous",
      "disguise",
      "mask",
      "privacy-mask",
      "translate",
      "translation",
      "language",
      "i18n",
      "localization",
      "l10n",
      "dark-mode",
      "night",
      "dark-theme",
      "crescent",
      "preferences",
      "config",
      "configuration",
      "gear",
      "cog",
      "sliders-horizontal",
      "adjustments",
      "filters-horizontal",
      "theme-toggle",
      "dark-mode-toggle",
      "appearance",
      "light-dark",
      "brightness-toggle",
      "tool",
      "spanner",
      "fix",
      "repair",
      "build",
      "configure",
      "company",
      "office",
      "organization",
      "enterprise",
      "corporate",
      "apartment",
      "board",
      "task-board",
      "columns",
      "view-kanban",
      "trello",
      "checkpoint",
      "flag-pennant",
      "diamond",
      "goal",
      "work",
      "business",
      "job",
      "portfolio",
      "career",
      "professional",
      "money",
      "cash",
      "bill",
      "currency",
      "payment",
      "dollar-bill",
      "price",
      "cost",
      "money-circle",
      "coin",
      "currency-coins",
      "change",
      "tokens",
      "dollar",
      "usd",
      "money-sign",
      "currency-dollar",
      "eur",
      "euro-sign",
      "currency-euro",
      "bank",
      "institution",
      "finance",
      "building-bank",
      "account-balance",
      "courthouse",
      "percentage",
      "discount",
      "rate",
      "percent-badge",
      "balance",
      "justice",
      "weigh",
      "scales",
      "legal",
      "purse",
      "billfold",
      "account-balance-wallet",
      "vehicle",
      "automobile",
      "driving",
      "auto",
      "directions-car",
      "clinic",
      "emergency",
      "local-hospital",
      "current-location",
      "near-me",
      "my-location",
      "find-location",
      "gps-fixed",
      "gps-fix",
      "my-location-fixed",
      "location-locked",
      "atlas",
      "geography",
      "map-trifold",
      "directions",
      "location",
      "location-on",
      "pin-drop",
      "place",
      "location-off",
      "no-location",
      "remove-location",
      "unpin-location",
      "add-location",
      "new-location",
      "add-place",
      "pin-plus",
      "airplane",
      "flight",
      "travel",
      "aircraft",
      "path",
      "navigation",
      "itinerary",
      "route-points",
      "journey",
      "milestones",
      "conversion-path",
      "arrow-path",
      "window",
      "desktop-window",
      "application",
      "browser-window",
      "cmd",
      "meta",
      "command-key",
      "keyboard-command",
      "bottom-panel",
      "dock-bottom",
      "layout-bottombar",
      "bottom-panel-close",
      "collapse-bottom",
      "layout-bottombar-collapse",
      "bottom-panel-open",
      "expand-bottom",
      "layout-bottombar-expand",
      "left-panel",
      "drawer",
      "navigation-panel",
      "sidebar-close",
      "left-panel-close",
      "collapse-sidebar",
      "drawer-close",
      "sidebar-open",
      "left-panel-open",
      "expand-sidebar",
      "drawer-open",
      "right-panel",
      "sidebar-right",
      "aside",
      "layout-sidebar-right",
      "right-panel-close",
      "sidebar-right-close",
      "collapse-right",
      "right-panel-open",
      "sidebar-right-open",
      "shutdown",
      "power-off",
      "on-off",
      "switch-off",
      "power-button",
      "divider",
      "horizontal-rule",
      "hr",
      "line-separator",
      "power-cell",
      "battery-standard",
      "battery-indicator",
      "battery-charge",
      "charging",
      "power-charging",
      "battery-100",
      "battery-complete",
      "power-full",
      "battery-empty",
      "battery-0",
      "battery-critical",
      "low-power",
      "battery-50",
      "battery-mid",
      "battery-half",
      "battery-alert",
      "battery-error",
      "battery-critical-alert",
      "desktop",
      "pc",
      "workstation",
      "desktop-tower",
      "device-desktop",
      "processor",
      "chip",
      "microchip",
      "computing",
      "cpu-chip",
      "hdd",
      "disk",
      "storage",
      "drive",
      "audio",
      "earphones",
      "headset",
      "input",
      "typing",
      "keys",
      "notebook-computer",
      "laptop-mac",
      "computer-desktop",
      "device-laptop",
      "portable",
      "display",
      "screen",
      "responsive",
      "devices",
      "device-phone-mobile",
      "multi-device",
      "cursor-device",
      "pointing-device",
      "print",
      "printing",
      "backend",
      "host",
      "rack",
      "hard-drives",
      "datacenter",
      "mobile",
      "phone-mobile",
      "device-mobile",
      "cell-phone",
      "iphone",
      "ipad",
      "device-tablet",
      "tablet-device",
      "television",
      "monitor-tv",
      "device-tv",
      "usb-port",
      "usb-drive",
      "usb-cable",
      "usb-connection",
      "smartwatch",
      "wristwatch",
      "device-watch",
      "timepiece",
      "web-camera",
      "camera-front",
      "video-camera-front",
      "facecam",
      "bt",
      "wireless-bluetooth",
      "bluetooth-disabled",
      "bt-off",
      "screencast",
      "chromecast",
      "airplay",
      "screen-mirror",
      "stream-to",
      "offline",
      "no-cloud",
      "cloud-slash",
      "disconnected-cloud",
      "cloud-refresh",
      "sync-cloud",
      "cloud-update",
      "cloud-connection",
      "world",
      "earth",
      "internet",
      "web",
      "globe-alt",
      "nodes",
      "hub",
      "connected",
      "mesh",
      "plugin",
      "socket",
      "outlet",
      "connector",
      "power-plug",
      "broadcast-tower",
      "cell-tower",
      "antenna",
      "transmission-tower",
      "tower",
      "wireless",
      "access-point",
      "modem",
      "gateway",
      "rss-feed",
      "feed",
      "syndication",
      "web-feed",
      "cell-signal",
      "signal-strength",
      "reception",
      "cellular",
      "bars",
      "disconnect",
      "unplugged",
      "plug-off",
      "power-disconnect",
      "network-wireless",
      "wi-fi",
      "wifi-strong",
      "wifi-full",
      "network-wifi",
      "signal-strong",
      "wifi-weak",
      "wifi-1-bar",
      "poor-signal",
      "weak-connection",
      "no-wifi",
      "wireless-off",
      "wifi-disabled",
      "no-signal",
      "wifi-none",
      "disconnected-wifi",
      "signal-none",
      "curly-braces",
      "brackets-curly",
      "json",
      "code-block",
      "data-object",
      "code-bracket",
      "issue",
      "defect",
      "bug-report",
      "debug",
      "error-bug",
      "bug-ant",
      "source-code",
      "markup",
      "code-brackets",
      "dev",
      "develop",
      "widget",
      "module",
      "extension",
      "docker",
      "box-package",
      "shipping-container",
      "deployed-code",
      "db",
      "datastore",
      "data-storage",
      "circle-stack",
      "sql",
      "db-backup",
      "backup-restore",
      "data-export",
      "database-restore",
      "compare",
      "file-diff",
      "code-diff",
      "git-diff",
      "difference",
      "branch",
      "version-branch",
      "fork-branch",
      "vcs-branch",
      "git-commit-horizontal",
      "commit",
      "version-commit",
      "compare-branches",
      "git-diff-branches",
      "pull-compare",
      "compare-arrows",
      "fork",
      "branch-fork",
      "repo-fork",
      "git-history",
      "commit-graph",
      "git-log",
      "merge-branch",
      "branch-merge",
      "pull-request",
      "pr",
      "merge-request",
      "pr-closed",
      "pull-request-closed",
      "merge-request-closed",
      "pr-draft",
      "pull-request-draft",
      "merge-request-draft",
      "log-file",
      "audit-log",
      "receipt-long",
      "event-log",
      "addon",
      "puzzle-piece",
      "integration",
      "add-on",
      "regular-expression",
      "regexp",
      "pattern-match",
      "code-search",
      "find-in-code",
      "grep",
      "search-source",
      "console",
      "command-line",
      "cli",
      "shell",
      "prompt",
      "var",
      "parameter",
      "code-variable",
      "callback",
      "http-hook",
      "api-hook",
      "webhooks",
      "pipeline",
      "flow",
      "process",
      "dag",
      "github-logo",
      "brand-github",
      "medal",
      "achievement",
      "ribbon",
      "badge-award",
      "prize",
      "premium",
      "king",
      "queen",
      "vip",
      "royalty",
      "pro",
      "dices",
      "random",
      "chance",
      "gamble",
      "casino",
      "roll",
      "celebrate",
      "celebration",
      "confetti",
      "hooray",
      "tada",
      "rating",
      "bookmark-star",
      "half-rating",
      "partial-star",
      "rating-half",
      "winner",
      "champion",
      "cup",
      "robot",
      "ai-bot",
      "chatbot",
      "smart-toy",
      "automation",
      "ai",
      "intelligence",
      "mind",
      "cognitive",
      "neural",
      "smart",
      "psychology",
      "magic",
      "auto-enhance",
      "stars",
      "glitter",
      "sparkle",
      "wand-sparkles",
      "auto-fix",
      "enhance",
      "wizard",
      "wand",
      "documentation",
      "manual",
      "reference",
      "textbook",
      "guidebook",
      "read",
      "reading",
      "open-book",
      "story",
      "novel",
      "flask-conical",
      "lab",
      "experiment",
      "science",
      "beaker",
      "chemistry",
      "test-tube",
      "school",
      "academic-cap",
      "education",
      "graduate",
      "mortarboard",
      "books",
      "bookshelf",
      "collection",
      "local-library",
      "cloud-storage",
      "saas",
      "hosted",
      "thunderstorm",
      "storm",
      "cloud-storm",
      "thunder",
      "rain",
      "rainy",
      "precipitation",
      "weather-rain",
      "cold",
      "winter",
      "freeze",
      "ac",
      "air-conditioning",
      "light-mode",
      "brightness",
      "sunny",
      "day",
      "temperature",
      "thermostat",
      "temp",
      "air",
      "breeze",
      "windy",
      "gust",
      "wheelchair",
      "accessible",
      "a11y",
      "disability",
      "calculate",
      "math",
      "computation",
      "arithmetic",
      "dot-large",
      "ring",
      "radio-button-off",
      "empty-circle",
      "cafe",
      "break",
      "mug",
      "espresso",
      "local-cafe",
      "ip",
      "rights",
      "legal-copyright",
      "medical",
      "first-aid",
      "hospital-cross",
      "health",
      "red-cross",
      "medical-cross",
      "unlimited",
      "infinite",
      "all-inclusive",
      "forever",
      "eco",
      "nature",
      "plant",
      "organic",
      "environment",
      "idea",
      "tip",
      "bulb",
      "light-bulb",
      "hint",
      "suggestion",
      "recycling",
      "sustainable",
      "rectangle",
      "box-empty",
      "shape-square",
      "crosshair-circle",
      "focal-point",
      "shape-triangle",
      "delta",
      "change-history"
    ],
    "disabled": [
      "disabled",
      "clickable"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "slate"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ]
  },
  "attributeClasses": [
    "disabled",
    "color",
    "size"
  ],
  "defaultValues": {
    "set": "",
    "href": "",
    "target": ""
  }
};
